var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuropeGermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Map-europegermany",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400.5,
    height: 199.589,
    viewBox: "0 0 400.5 199.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2395",
    "data-name": "Rectangle 2395",
    width: 400.5,
    height: 199.589,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2394",
    "data-name": "Rectangle 2394",
    width: 400,
    height: 199.09,
    transform: "translate(0.249 0.249)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2642",
    "data-name": "Group 2642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2647",
    "data-name": "Group 2647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2646",
    "data-name": "Group 2646",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2645",
    "data-name": "Group 2645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2644",
    "data-name": "Group 2644",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2643",
    "data-name": "Group 2643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2642-2",
    "data-name": "Group 2642",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M398.459,173.189l1.79,2.38-6.21,4.42.85-2.72,2.55-2.55v-3.83l1.02-.42Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M392.289,123.489l-1.38.47-3.44-2.47,1.32-.09Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M391.489,179.649v1.7l-9.95,6.55-2.98-1.7Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M389.749,123.949v1.72l-2.96,1.66-1.7-1.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M387.459,133.129l-3.83-.78-4.2-4.1-3.24,2.98-1.7-.6v-9.17l8.45,4.42-.23,2.51Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M370.649,145.969l6.64,9.35-.68,7.06-12.08,12.5-10.46-.6-1.28-7.06-3.57,1.53-3.4-2.97-20.67,4.52-1.28-1.53,1.7-4.09V152.6l10.89-5.1,8.08-8.93,4.42,1.96,1.96-4.08,7.4-.17-1.87,3.4,6.12,5.27,4.08-4.08v-5.7l1.88.59Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M374.489,121.459v9.17l-4.66-1.62,1.81-1.1-.98-2.79-5.44-2.27-2.2.08.42-2.05,3.73,1.47,3.53-2.87,3.79,1.97Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M365.009,118.209l.47,2.53-4.37-1.98Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M362.709,52.279l-1.06,1.82-2.5.03-.78,1.06-1.1-.65-.11-4.59Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M359.779,121.249v.92l-3.56.37.37-1.29Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M357.409,112.959l.59.72-.96,1.19.37,2.59-1.64-.4.45-2.92Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M354.369,44.329l2.83,4.02h-1.69l-2.28-4.25-4.66-5.75,1.64.05,5.8,5.93Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M359.149,65.249l-.13,1.68-1.25.53-.43-2.12-5.5.81.41-1.41,4.6-1.19,3.4-3.09-.95-4.39,1.67.49,1.67,2.92.2,4.83Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M356.589,66.529l-.96,1.74-1.27-1.44Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M353.269,67.209l.65.96-.72,2.26-1.92-2.97Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M352.229,98.579l1.44,2.31h-1.51l-1.38-1.78Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M351.479,106.919l-2.74-1.95h3.29l1-2.62,1.36,4.24-1.6.41.67,1.22-1.98.6Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M351.819,129.839h3.53v.97l-2.6.31-.93-1.27Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M351.819,129.849l.93,1.27-1.44,1.29-1.61-.2Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M350.779,100.609l.78,1.36-.62.82-1.09-1.64Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M349.139,101.979l.71,1.07-.71.85-.8-.99Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M349.009,62.309l-.45,3.06-2.66.19-2.19-4.75,1.62-1.5Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M348.909,130.119l-.85.69h-2.02l-.41-1.37h2.12Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M347.039,100.849l.64-1.16,1.46.18-1.1,1.66Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M347.039,98.839l-.46.85-1.14-1.11.19-1.13Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M347.2,118.709l3.22-.13-2.02,1.69,1.07,2.35v1.48l-1.89-.66-.78-2.06-.93,1.03.48,2.78-1.58.48-.79-4.03,1.26-1.69-.15-3.11,2.18-1.97,3.29.8,1-.65,1.53.03-1.74,2.06-1.17.1-2.36-.81-1.28,1.4Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M346.8,97.309l-2.82-3.39.49-4.25,1.99.04,1.09,2.41-1.1,2.52,1.1,1.37,3.02.32-.47,1.4Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M345.629,131.319l.51,1.1h-1.47l-.62-.76Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M345.439,53.5v.01h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M342.169,55.759l3.26-2.25h.01l.37,4.19-2.1.28,1.62,1.33-1.62,1.5-2.09-.59-1.58-2.99Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M344.719,100.539l.05,1.62-2.38,1.97-1.33-.26Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M343.619,79.439l1.12,1.17-1.12,3.14-1.83-1.71Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M343.069,110.349v.01l-2.37.24Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M342.169,55.759l-2.13,1.47v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M338.989,129.439l.2.95-13.7-2.32,2.06-1.65,3.42,1.3,3.08-.68Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M340.629,107.769l2.44-.2v2.78l-2.37.25-1.92,3.63-6.44,1.44-1.39-.84,6.76-3.12Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M332.339,115.669l6.44-1.44,1.92-3.63,2.37-.24v7.62l-3.29,4.2h-6.65l-2.09-3.66-.13-3.68.04-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M330.419,87.449v1.24l-1.3,1.62-.89-1.08v-1.29Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M329.909,37.579h-6.37v-.01h6.38l6.58,6.44,8.94,2.28V53.5l-.01.01V46.3l-8.95-2.28Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M327.549,46.289v.01l-3.84-.62Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M327.179,48.349l-5.52,1.15-2.05,4.19-17.08-.19-14.76-8.62,4.51-3.44,6.07,1.85.01-.01h.01l1.63-3.69,14.93,3.7h7.32l1.46,2.39,3.84.62Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M327.339,96.019V99.1l-2.74,2.05-1.85.26-1.64-1.63v-2.73l1.03-1.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M326.179,121.629v2.81l-2.01,1.67-12.7-17.29,3.75,1.43Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M320.069,107.5l4.56,6.73-.38,1.47-4.83-4.12-1.17-3.81,1.81-.27Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M327.339,94.689l-1.85-1.97-2.53-2.69-.68-.72V89.3l-1.13-3.47-3.52-1.72,4.62-2.34,4.23,3.62-1.95,1.11-.27,3.17,5.48,5.8.18,5.16-5.25,3.47-.07-2.95,2.74-2.05v-4.41Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M325.489,92.719l1.85,1.97v1.33h-5.2l2.32-2.33-2.48-3.38h-4.39v-2.75h-.01l-1.81-1.06v-1.45l1.86-.94,3.52,1.72,1.12,3.47.01.01.68.72Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M322.249,43.279v.01h-7.32L300,39.589l.01-.01,14.93,3.7Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2380",
    "data-name": "Rectangle 2380",
    width: 0.01,
    height: 2.75,
    transform: "translate(317.579 87.559)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M317.819,96.519l-.68,6.67,2.92,4.31-1.81.27h-.01l-.29-.93-3.01-2.56.1-1.68.01-.02v.02l1.72-3.38-3.1-11.19,2.09-1.53h.01l1.81,1.06v2.75h4.4l2.48,3.38-2.32,2.33-1.03,1.03v2.73Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M316.769,99.219l-1.72,3.38v-.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M312.069,78.889l3.7,6.16h-.01l-3.7-6.16.96-2.6Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2381",
    "data-name": "Rectangle 2381",
    width: 0.01,
    height: 1.45,
    transform: "translate(315.759 85.049)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M315.759,86.5l-2.09,1.53v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M313.669,88.029l3.1,11.19-1.72,3.36.26-4.25L314.2,94.2l-2.01-2.26-1.08,1.35-1.51-.45-.81-4.27-2.14-1.79.31-2.12v-.01l1.05-7.22,2.86-2.06h.01l2.14.92-.96,2.6,3.7,6.16V86.5l-2.09,1.52Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M310.879,75.359l-.01.01-4.84-2.09.01-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M308,77.439l.01-.01-1.05,7.22Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M302.759,76.279l-.01.01L299.6,75.2Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M302.749,76.289l-.68,1.42-1.53-.38L299.2,77l.4-1.8Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M304.469,82.319l2.49,2.34-.31,2.12-4.74-3.98-1.07,1.03-1.65-5.21,1.17-.55,1.71,2.28,1.99-.82Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M304.059,79.529l-1.99.82-1.71-2.28.18-.74,1.53.38.68-1.42.01-.01,3.27-3,4.84,2.09-2.86,2.06-.01.01-1.04,7.21-2.49-2.33Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M275.529,82.969l-2.71-.86-.27-.32,3.27-.88v-2.24l-1.82-.68.01-2.58h2.43l3.8-3.5V71.9l-.84-3.41v-.01l-1.75-.99.08-1.75,2.89-2.05h1.95l2.1.96.27,5.48h.01l2.41.84-.02,3.08,9.67,3.66,1.76-2.8.82.29-.4,1.8h.01l1.34.33-.18.74-1.17.54v.01l1.65,5.21-10.01,9.67-.68,7.99-4.39,2.7-6.91-19.88L278,84.3l-.38,1.78-2.16-.25-1.2-1.56Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M298.769,74.909l-1.76,2.8-9.67-3.66.03-3.08Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M298.769,74.909l-11.4-3.94v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M298.359,43.279l-.01.01-6.07-1.85.02-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M287.759,44.879v.01l-6.38,4.86-.01.01,1.07,4.93-4.09-1.89-.01-.01-6.4.28-2.71,2.23-2.77.12-2.88-3.79-3.93.75-.46-.31-4.24-2.91-3.56.83.4,5.01-2.31-1.93-2.61.72-2.05-1.7.09-2.24,3.11-1.51-2.56-1.73-4.3,1.73-2.01-2.51V40.9h14.98v-.01h.02v-3.83l8.44-1.89,21.47,7.57,3.68,2.15Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M287.369,70.959v.01h-.01v-.01l-2.41-.83-.28-5.48-2.1-.96h-.01l-4.05-1.85-.63-.29-1.26-3.09-.57-1.39,6.39-2.37v-.01l-1.06-4.94,6.38-4.86,14.77,8.62,17.08.18,2.06-4.18,5.51-1.16.37-2.05v-.01l-3.84-.61-1.46-2.39v-.01l2.72-.54v-.01h.02l-1.45-5.15h6.37l6.57,6.44,8.95,2.28v7.21l-3.26,2.25-2.13,1.46v.01l-2.81,1.93-2.01-3.83-2.92,2.56,2.3,3.77,1.17-.76h3.66l-3.18,3.47,6.19,10.19-3.47,7.77-10.62,3.79-.06-1.74-1.8,1.02-.01-.01-4.23-3.62-4.62,2.34-1.86.94-3.7-6.16.95-2.6-2.14-.92h-.01l.01-.01-4.84-2.09-.01.01-3.27,3L299.6,75.2h-.01l-.82-.29Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M287.359,70.959v.01l-2.41-.84Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M284.669,64.649l.28,5.48h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M281.379,49.749l1.06,4.94-1.07-4.93Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M278.509,61.839l4.05,1.85h-1.94l-2.89,2.05-.08,1.75,1.75,1,.84,3.41-3.8,3.5H274v2.59l1.82.69v2.23l-3.28.87-1.97-2.24h-7.49l1.73-2.97-1.91-2.4-.33-.93-.1-.28,5.36.05,4.99-4.61v-.01l1.37-5.93Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M276.619,58.459l1.26,3.09h-.01l-1.26-3.09Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M276.619,58.459h-.01l-.57-1.39h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M275.819,78.669v.01l-1.82-.69Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M275.819,80.909l-3.27.88h-.01v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M273.309,59.959l.88,2.5-1.37,5.93-4.99,4.62-5.36-.05-2.31-6.73,1.09-2.33,5.34-2.74h.01l2.87.77h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M274,75.4h2.44l3.8-3.5v.01l-3.8,3.5h-2.43l-.01,2.58Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M278.509,61.839l-4.32.62-.88-2.5-3.83,1.97-1.31-3.85,1.34-.39,3.44,1.12,3.66-.35,1.26,3.09h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M272.819,68.389v.01l-4.99,4.61Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M271.939,53.079l6.41-.28,4.09,1.89v.01l-6.39,2.37h-.01l.57,1.39-3.66.35-3.44-1.12,2.75-.79h.01l.23-1.74h-.02l-3.24.15Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M262.609,35.149l21.48,7.58,3.67,2.14v.01l-.02.01-3.68-2.15-21.47-7.57-8.44,1.89Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M239.679,58.7l1.92-.18,2.66-.27,2.33,4.11h4.23l.06-1.47,3.32-1.1,5.61,1.78.89,1.44.55.89-1.1,2.32.01.01,2.31,6.73.1.28.32.93,1.92,2.4-1.73,2.97H260.7l-8.58-2.56-4.66-4.87-2.01-.19-6.76-11.47V58.8Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M259.649,52.389l3.92-.75,2.88,3.79,2.78-.12h.01l3.24-.15-.22,1.74-2.75.79-1.34.39h-.01l1.31,3.85-2.87-.77h-.01l-8.8-7.05h-3.73l-2.27.9V55l-.4-5.01,3.56-.82,4.24,2.9Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M256,83.639l-1.71-.23.01-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M256,87.559v-3.92l-1.7-.24,3.13-3.19,3.86,3.43-6.97,8.64-2.11-1.43v-2.27Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M254.3,83.4l-.01.01-.8-.12Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2382",
    "data-name": "Rectangle 2382",
    width: 14.98,
    height: 0.01,
    transform: "translate(239.149 40.889)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M253.739,81.469l2.26-2.54,1.43,1.28L254.3,83.4l-.81-.11-1.42-.2-1.19-2.19Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M252.209,90.849l2.11,1.44-13.85,6.24-1.88-6.16,1.1-1.9,3.78.48-.35,1.43v.01l5.35-2.81,3.74-1Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M251.029,57.249l-4.16-3.45,2.61-.72,2.31,1.93,2.27-.9h3.73l8.8,7.05-5.34,2.74-.55-.89-.88-1.44h-.01l-5.61-1.78-3.32,1.1Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M250.759,79.539l-.76.78-1.16-.77.59-1.88Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M249.879,136.3l-5.89,18.9-3.47-.15-1.44-3.42,1.17-3.29.68-4.93,6.85-7.11Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M246.049,105.389l-6.67,5.56h-8.03l-.91-.95-.01-.01-4.71-4.93,4.07-9.62h5.76l2.34,3.7-.89.74,3.02,3.37Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M243.849,71.769l1.6,2.6h-1.32l-.93-1.22H242l.34-1.38Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M242.409,54.989l1.85,3.26-2.67.26-2.44-2.23,1.25-1.79,1.99.5Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M244.259,58.249l-2.66.27-.01-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M242.389,54.979v.01l-1.99-.5Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M240.609,73.139l-8.07-4.21-.02-.08-.39-1.63,2.23-1.34,1.22-4.8,3.07-.62,6.66,11.3-2.97.01-.34,1.38Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M241.6,58.519l-1.92.18,1.91-.19Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M240.4,54.489h-.02l-4.62-2.1h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M246.049,105.389l-6.03-2.14-1.51-1.7,1.49-1.07.54.92,10.25-1.52.6,3.01-14.75,17.16v-6.82l2.73-2.28h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M240,100.479l-1.49,1.07L237,99.879l.89-.74.89-.75.49.84Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M232.849,88.209l5.93,10.18-.89.75-2.34-3.7h-5.76v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M239.149,56.279l2.44,2.23-1.91.19-.99.1-1.17-2.52Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M238.649,58.8v1.65l-3.07.62-2.7.55-4.75.97L217.419,62l-2.33-4.68,2.83.02.5-.59.76-.91,14.66-.48,3.63.92Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M235.579,61.069v.01l-2.7.54Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M235.579,61.079l-1.22,4.8-2.23,1.33-2.75,1.64-1.65-1.15,1.24-2.3-1.35-.47.5-2.33,4.76-.98Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M234.949,52.559l-.93.21v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M234.149,122.949l-7.07-4.66v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M234.019,52.769l.02.03-.07-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M234.039,52.8l-.02-.03.93-.21.8-.17h.01l4.62,2.1h.02l-1.25,1.79h-1.63l-.05-.01-3.58-.91v-2.57l.08-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M234.019,52.759v.01l-.05.01v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M233.969,52.769v.01l-.08.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M231.119,69.449l-.53,3.08.52-3.08Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M230.089,44.629l.42-.94-1.09-.44v-.01l1.11.45-.43.96Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M230.439,110l.91.95h8.02l-2.73,2.28h-.01v6.82l-2.48,2.9-7.07-4.67,1.16-2.03v-.01l.36-2.7-.74-3.18Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M230.429,109.989l-7.44,1.05-4.2-1.53-.01-.01h.02l-7.84-9v-5.11l2.21-2.18V93.2l.22-4.96.2-4.6h13.1l2.63-1.51,3.53,6.07v.01l-3.06,7.22v.01l-4.08,9.61.01.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M229.419,43.249l1.09.44-.42.94-.08-.16.35-.78-.89-.36-.01-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M230.359,43.689l-.35.78-.01-.02.34-.76-.87-.36Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M230.339,43.689l-.34.76-.53-1.12Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M230.1,44.649l-.87,1.96h-.02l.88-1.98Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M230,44.449l.01.02-.95,2.14h-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M229.469,43.329l-8.39-3.41.01-.01,8.37,3.41Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M229.419,43.249l.04.07-8.37-3.41.09-.02h.01l8.23,3.35Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M229.419,43.239l-8.23-3.35h.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M229.379,68.849l2.75-1.64v.01l.39,1.63-.07.03-1.33.57h-.01l-.52,3.08-1.72.8-1.14-.14V67.7Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M229.229,46.609l.87-1.96,3.92,8.11-.05.01-5.38-1.88-.27-2.4,1.51-.41-.62-1.46v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M229.209,46.609v.01l-.16.03-.01-.03v-.01h.02l.95-2.14.08.16Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M228.869,73.329l1.72-.8.53-3.08,1.33-.57.09.05,8.07,4.21,1.39.01h1.19l.94,1.22v.01h1.32l3.02,4.93.37.24,1.16.77.88.58,1.19,2.19,1.42.2.8.12,1.71.23v3.92l-3.79,1.02-3.74,1-5.35,2.8.35-1.43-3.78-.48-1.1,1.9-.22-.69-10.64-18.49Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M228.6,113.539l-.36,2.7h-2.52l-.97,1.69h-3.4l1.64-6.89,4.87-.68Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M229.209,46.619l.62,1.46-1.51.41.27,2.4,5.38,1.88-.08.02v.01h-.02l-5.45-1.91-.27-2.4,1.51-.41-.61-1.43Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M227.129,67.259l.49-2.33,1.35.47-1.24,2.3Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M227.129,67.269l.6.43v5.49l-.03.07-1.52-2.48Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M227.6,139.379v.01l-.23-.19Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M229.429,140.989l-1.83,1.6v-3.21l-.23-.18-1.6-1.32-.05.04v-6.88h1.78v5.93l1.93,1.28Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M225.769,137.879l1.6,1.32-1.6-1.31-.05.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M225.119,156.379l-1.56.03V150.8l2.16-5.05v-3.16l-3.46-2.26,3.46-2.41.05-.03,1.6,1.31.23.19v3.2l1.83-1.6v-2.74l-1.93-1.28v-2.2h.01l7.56-1.57.75,7.11-7.6,6.24.24,6.81-3.24,2.26Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M226.879,18.619l-2.93,1.46-.14-.01,2.9-1.44-11.48-3.67.15-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M214.239,69.149l11.94,1.63,1.52,2.48-.03.07-.8,1.89L223.9,72.8l5.42,9.33-2.63,1.5H213.6l.64-14.47Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M226.069,21.359l-6.03,2.47-.03-.06,15.65-6.42,16.9-.46-2.1-4.78,4.37.34,2.47,8.09,2.74-2.83-3.17-3.93,14.49-6.48H287.8l1.1,3.93h17.81l3.28,2.46h7.88l2.74-2.46,9.73,1.59,1.57,2.13,27.9.8,18,3.56,2.81,3.01-3.5-.07-5.16-1.06-2.24,1.75,5.76,1.57-.14,1.17-11.47,3.63,4.84,4.66v7.85l-8.58-8.12.26-4.31,2.11-1.45-2.19-2.1-1.26-.13-.02,1.89-5.08-1.92-1.31,4.09-12.05-.09-1,7.21,5.84.09,6.03,6.85v5.85l-2.11,3.15-3.91.68v-7.22l-8.94-2.28-6.58-6.44h-6.38v.01h-.03l1.46,5.15v.01l-2.72.54h-7.31l-14.93-3.7-.01.01h-.01l-1.63,3.69-6.06-1.85-.02.01-4.52,3.43-3.67-2.14-21.48-7.58-8.46,1.91v.01h-.02v3.82h-14.98v.01h-.02v4.94l2.01,2.51V52.8l1.25,2.18-1.99-.49-4.63-2.1h-.02l-.8.17-.93.2-3.92-8.11.43-.96-1.11-.45-6.47-13.39Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M225.769,63.789l-.87,1.68-2.18-.55Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M225.719,131.039v6.88l-3.46,2.41-4.89,3.4h-4.82l-2.58-3.2v-3.56h3.15l-.1-3.97,8.05,3.97.96-1.92h-.01l-2.73-1.1.82-3.69,4.56-.69Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M224.089,119.059h2.55l.44-.77,7.07,4.66.93,10.25h-.01l-7.56,1.57v-3.73h-1.79l-1.05-1.47-3.68-5.19,1.55-3.83,1.05-2.62h1.16Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M225.889,50.169l-1.93-2.47,5.08-1.08.01.03-4.92,1.05,1.93,2.47-2.04.16-.02-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M223.809,20.069l-.03.02-5.83-.22v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M223.429,48.349h.17l-1.09,1.13,1.49.84-.15.01-1.51-.85Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M223.589,117.929l-1.05,2.62h-.01l-1.89.4.71-3.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M223.559,156.429v1.77l-1.53-.92v-1.37h1.53v.52Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2383",
    "data-name": "Rectangle 2383",
    width: 1.53,
    height: 0.03,
    transform: "translate(222.029 155.879)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M222.539,120.549l-1.55,3.83,1.54-3.83Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M222.529,120.549l-1.54,3.83-.87-1.24.52-2.19Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M220.109,160.169h-1.64l-1.56,1v1.86h2.01l1.19-1.24v-1.62Zm4.63-1.17-8.29,9.6h-10.77l-3.28-8.99h5.66v-5.17l2.28,2.63,9.3-6.23h3.92v5.04h-1.53v1.43l1.53.92v-1.8l1.56-.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M218.919,38.959l2.27.93h-.01l-2.28-.92Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M221.089,39.909l-.01.01-.06-.03h.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M221.079,39.919l-3.71.81-.09-.01v-.01h.02l.07.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M221.079,39.919l-3.71.8-.07-.01,3.05-.67.67-.15Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M221.019,39.889l-.67.15.66-.15Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M221.009,39.889l-.66.15-3.07.67-6.04-.96-.68-1.88,3.25-2.76,1.03-.87h2.89l2.37,3.85-1.25.81-.12.07Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M220.989,124.379l3.68,5.19-4.56.68v.01l-.83,3.69h.01l2.73,1.1-.95,1.92-8.05-3.97-2.5-1.24v-4.55h-.01v-.01h-2.82l-.57,2.01-2.81.09-.17-.56-.56-1.96h-.01l-4.46.03h-.01l-.85-1.13,3.78-1.72v-.01l3.97-6.59.63-4.91v-.01h.01l.33-2.6.33-.01,11.49-.32,4.2,1.53-1.64,6.89-1.24,5.2.01.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M220.349,40.039l-3.05.67h-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M217.919,34.239l2.37,3.85-.17.1.15-.1-2.37-3.85Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M220.109,160.2v1.56l-1.19,1.24h-2.01v-1.8l1.56-1Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M220.109,160.169v.03h-1.64l-1.56,1v-.03l1.56-1Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M217.369,24.989l-4.43-9.91,2.29-.12,11.48,3.67-2.9,1.44-5.86-.21v.01l-.17-.01,2.08,3.97.15-.06.03.06,6.03-2.47-3.12,8.49,6.47,13.39-8.22-3.35h-.01l-2.27-.93,1.2-.77.17-.1-2.37-3.85h-3.08l-.37-2.6-.41-2.96-.02.02v-.02l.65-.6h.01l2.6-3.01.06-.07Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M217.949,19.869l2.06,3.9-.15.06-2.08-3.97Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M219.639,150.8v.01l-9.3,6.23-2.28-2.63v-9.32h7.51L218,148.5Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M221.179,39.889l-.09.02-.06-.02-2.27-.93.09-.06,1.27-.81-2.37-3.85h.15l2.37,3.85-.15.1-1.2.77-.02.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M210.959,100.5l7.84,9h-.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M210.959,100.5l7.82,9-11.48.33-.33.01h-.01l-.33,2.6h-3.96l-2.55-3.6.91-3.65v-.01l1.96-.92Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M218.729,38.969l.12-.07-.09.06,2.27.93h-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M218.189,49.329l.32-.98h.17l-.34,1.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M218.349,46.609l-1.36,2.13-.02-.03V48.7l1.34-2.09-.79-1.51h.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M217.519,45.1l.79,1.51-1.34,2.09-1.75-3.6Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M218.189,49.329v.01l-1.07-.45Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M218.129,49.389l-1.08-.46,1.12.46.02-.05.11.05-.68,2.1-.16-.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M218,148.5l-2.43-3.41h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M217.749,34.239l2.37,3.85-1.27.81,1.25-.81-2.37-3.85Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M216.659,54.059l1.03,2.22h-2.44l-.03-1.75Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M217.689,45.1h-.17l-.01-.01h.17Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M217.519,45.1h-2.3v-.01h2.29Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M215.959,51.049l1.5.42-.01.02-1.58-.43Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M216.659,54.059l-.02-.05h-.01l.82-2.5-1.61-.45h.03l1.58.43.01-.02.16.04-.82,2.5-.02.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M217.359,25l-4.43-9.92h.01l4.43,9.91Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M217.3,25.069l-2.6,3.01h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M211.239,39.749l6.04.96h-.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M217.279,40.709v.01l-.07.01-5.96-.95,5.96.94.04-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M217.249,40.709l-.04.01-5.96-.94-.01-.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M212.769,15.089l4.43,9.9-.01.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M217.189,25l-2.66,3.08h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M209.419,45.1v-1.55l2.2-2.74-.37-1.03,5.96.95.07-.01.09.01,3.71-.81,8.39,3.41.53,1.12-.96,2.16v.01l-5.08,1.08,1.93,2.47-1.89.15-1.49-.84,1.09-1.13h-5.09l-.32.98-1.07-.44-.04-.02,1.44-2.26-.8-1.51h-.03l-.01-.01h-7.43l-.01.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M218.479,46.609l-1.43,2.24-.03-.04-.03-.06v-.01l1.36-2.13-.8-1.51h.14Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M218.519,46.609l-1.44,2.26-.03-.01v-.01l1.43-2.24-.79-1.51h.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M217.049,48.929l-.14-.06Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M217.019,48.809l.03.04-.01.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M217.119,48.889l1.07.45-.02.05-1.12-.46-.14-.06.08-.12.03.06.02.05.01-.01v.01l.03.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M216.969,48.709l.02.03v.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M216.989,48.749l-.08.12-.03-.01v-.01l.09-.14Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M216.879,48.849l-.01.01-1.79-3.7Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M216.809,54.009l1.05,2.27h-.17l-1.03-2.22.12-.04h.02v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M216.8,54.009v.01h-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M216.659,54.059l-1.44.47v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M217.459,51.449l-1.5-.42-.15.02-.02-.01-5.65.64-2.32-3.85,2.59-2.73h4.64l.03.06,1.79,3.7.01-.01v.01l.03.01.14.06,1.08.46Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M215.959,51.029l1.5.42v.02l-1.5-.42-.09.01-.06-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M215.839,51.059l-5.69.65V51.7l5.43-.63.23-.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M215.789,51.039l.02.01-.23.02-5.44.62v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M215.579,145.089l-.98-1.36h2.77l4.89-3.4,3.46,2.26v3.16l-2.16,5.05h-3.92L218,148.5Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M214.6,143.729l.98,1.36h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M215.579,51.069l-5.43.63-.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M215.249,56.279h-.01l-.02-1.75Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M215.219,54.529l.02,1.75h-.16l-.03-1.69Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M215.219,54.519v.01l-.17.06v-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2384",
    "data-name": "Rectangle 2384",
    width: 0.17,
    height: 0.01,
    transform: "translate(215.049 45.089)",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M216.639,54.009l.02.05-1.44.46-.17.05v-.04l1.58-.51v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M215.049,45.1h.17l1.75,3.6v.01l-.09.14-1.8-3.69Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M215.049,54.519l1.58-.51v.01l-1.58.51Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M215.049,54.589l.03,1.69h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M215.049,54.569v.02l-3.23,1.04v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M215.049,45.089v.01h-4.64l.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M215.049,54.529v.04l-3.23,1.05-.02-.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M215.049,54.519v.01l-3.25,1.05v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M214.469,31.639l.37,2.6h-.02l-.36-2.6Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M214.459,31.639l.36,2.6h-.15l-.36-2.55Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M214.669,34.239h.17l-1.03.87-.1-.05Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M212.929,15.079l4.43,9.92-.06.07-2.61,3.01h-.16l2.66-3.08.01-.01-4.43-9.9Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M214.309,31.689l.36,2.55h-.02l-.35-2.55Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M208.059,154.439v5.14H202.4l-5.63-15.85H214.6l.97,1.36h-7.51v9.35Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M214.059,28.679l.41,2.96h-.01l-.42-2.94Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M214.039,28.7l.42,2.94-.15.05-.01-.01v-.04h.01l-.4-2.82Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M213.909,28.819l.4,2.82h-.02l-.4-2.8Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M214.3,31.679l.01.01h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M214.3,31.639v.04l-.01-.03v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M214.3,31.679v.01l-1.17.35-.05-.03,1.21-.36Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M214.3,31.689l-1.17.36-.06-.03.01-.01.05.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M214.289,31.639v.01l-1.21.36Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M214.239,69.159l-.64,14.47-.01.01-.2,4.6-8.62-5.53h-9.16l-2.35-11.28,3.62-3.88v-.01l3.88.93,1.81,2.2,4.57.91,2.08-3.1Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M214.689,28.079l-.65.6v.02l-.13.12-.02-.14-.02.02v-.02l.65-.6h.17Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M213.889,28.679l.02.14-.02.02-.02-.14Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M213.869,28.7l.02.14-.6.56h-.16Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M213.809,35.109l-3.25,2.76-.04-.1,3.13-2.66.05-.05h.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M213.7,35.059l-.05.05Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M213.169,93.2v.01l-2.21,2.18v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M213.069,32.009h.01l-.01.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M211.169,30.949l1.9,1.06h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M210.519,131.759l2.5,1.24.1,3.97h-3.15v3.56l2.58,3.2h-15.77l-.23-2.74,2.56-4.2v-9.98l4.46-.03.57,1.96.17.56v.01l2.81-.1h.01l.57-2h2.81v4.55Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M212.879,32l-1.82-1.02.11-.03,1.89,1.06-.1.03h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M213.069,32.009v.01l-.11.03-.01-.01h.01l.1-.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M212.879,32l.07.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M212.769,15.079l2.44-.13.02.01-2.29.12h-.01l-.16.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M211.059,30.979l1.82,1.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2385",
    "data-name": "Rectangle 2385",
    width: 0.01,
    height: 0.01,
    transform: "translate(212.759 15.079)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M211.8,55.569v.01l-.15.05v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M210.459,57.569l1.32,2.88-1.18,1.87-.09-.12,1.1-1.75-1.32-2.88,2.62-1.29h.17Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M211.649,55.629l-3.63,1.17,3.63-1.18Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M211.819,55.619l-3.65,1.18-.15.05V56.8l3.63-1.17.15-.05Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M211.649,55.619l-3.63,1.18-.02-.15-.18-2.45v-.01l2.96-.58h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M211.819,55.629l-3.65,1.17,3.65-1.18Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M211.029,39.749l.38,1.06-2.17,2.72-5.12-.62-.22-.09h-.01l-3.7-1.46-.35-4.73h.35l3.8-.93.58.54.16-.01.01.01,2.57-.08,2.6.48.44,1.23Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M211.209,39.769l.37,1.04-2.19,2.74-.12-.01,2.19-2.73-.38-1.06Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M209.419,43.549V45.1h-.04v-.65h.01v-.9l2.19-2.74-.37-1.04.04.01.37,1.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M211.139,29.439l-1.33.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M211.009,30.949l-.84.2-1.11-.85.32-.82.43-.01,1.33-.03,1.99-.04h.16l.6-.56.4,2.8-1.21.37h-.01l-1.9-1.06-.11.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M211.169,33.9l2.53,1.16-.05.05-2.64-1.21L207.5,33v-.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M210.939,53.579l.86,1.99-.15.05-.86-2.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M211.8,55.569l-.86-1.99h.01l-.03-.06-.77-1.81,5.69-.65,1.61.45-.82,2.5-1.58.51Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M210.959,100.489v.01l-7.97,3.76Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M210.919,53.519l.03.06h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M210.149,51.709l.77,1.81-.78-1.81Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M211.079,39.749l-.68-1.88.09-.08.03.08.68,1.88.01.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M210.769,53.579l.01.03-2.96.58-.02-.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M210.729,53.469l.05.11h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M210.559,37.869l.68,1.88.01.03-.04-.01-.01-.02-.68-1.88-.03-.08.03-.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2386",
    "data-name": "Rectangle 2386",
    width: 0.01,
    height: 4.55,
    transform: "translate(210.509 127.209)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M210.459,15.209v1.57h-.17v-1.56Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M210.459,15.2v.01l-.17.01V15.2l2.47-.12v.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M210.459,16.779V15.2l2.3-.11h.01l4.42,9.91-2.67,3.08h-4.57l-3.12-1.58,2.67-6.05h-.88l-.03-.06-.73-1.77-.75-1.84h3.35Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M210.419,45.089l-.01.01h-.17l.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M210.409,45.1l-2.59,2.73h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M210.409,45.1l-2.6,2.73-.14.03-.02-.03,2.59-2.73Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M210.289,15.219l-3.42.17,3.42-.18Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M210.169,31.149l.84-.2.05.03-.85.2Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M210.049,31.179l.12-.03.04.03.25.18-.27,1.23-.15-.07.25-1.16Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M209.979,51.709l.16-.02.01.01v.01h-.01l.78,1.81.02.06-.15.03h-.01l-.01-.03h.01l-.05-.11Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M210.079,36.629v.01l-.03-.01h.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M209.979,51.7l.16-.02v.01l-.16.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M209.939,36.609l.11.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M210.039,32.519l-.02.07-2.53-1.15v-.08Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M210.079,36.639l.41,1.15-.09.08-.45-1.24-.01-.02.11.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M209.979,51.709l.75,1.76-.76-1.76Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M209.939,36.6v.01h-.05v-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M211.459,40.809l-2.19,2.73-.03-.01,2.17-2.72-.38-1.06-.68-1.88-.44-1.23v-.01h-.01l-.01-.02h.05l.01.02.45,1.24.68,1.88Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M209.909,36.629v.01l-2.6-.48.03-.01,2.56.48Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M209.889,36.609l-2.41-.45v-.01l2.41.44Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M206.829,26.5l3.12,1.58h-.17l-3.12-1.58,2.67-6.05h.17Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M207.469,34.789l2.05.69.55,1.15h-.02l-.11-.02V36.6l-.55-1.13-1.92-.64Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M209.389,43.549v.9h-.01l-.12.02v-.92l.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M209.379,44.449v.65h-.12v-.63Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M209.209,29.479h.17l-.32.82,1.11.85-.12.03-1.16-.88Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M207.479,36.149l-.01-1.29,1.88.62.54,1.11Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M207.469,34.859v-.03l1.92.64.55,1.13-.05-.01-.54-1.11Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M209.259,44.469v.63h-.05v-.62Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M209.259,43.549v.92l-.05.01v-.03h.01v-.9l.02-.02.03.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M208.589,20.389l.03.06h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M208.449,20.449l-.76-1.83-.75-1.84h.16l.76,1.84.73,1.77.02.06Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M207.689,18.619l.76,1.83h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M207.689,18.619l.75,1.83h-1.09l-5.56,6.07,2.47,3.07-5.17,4.58-3.17-3.64,1.19-1.85v-5.6l8.59-6.3h1.23Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M207.969,56.869l.05-.02v.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M207.969,56.869l-.67.22Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M211.169,33.9l-3.67-.94-.01-1.52,2.53,1.15.02-.07.15.07.27-1.23-.25-.18.85-.2,1.82,1.02.07.04.01.01.11-.03.06.03,1.17-.36.35,2.55h.02l-.96.82h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M207.109,16.779l.75,1.84-.76-1.84Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M207.849,56.849v.01l-.14.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M207.829,56.649l-.19-2.46h.01v.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M207.8,54.159l.02.03h-.01l-.02-.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M207.819,47.829l2.32,3.85-.16.02-2.31-3.84.14-.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M207.819,54.2l.18,2.45-.19-2.46h.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M207.809,54.189l.19,2.46.02.15-.17.05-.02-.2-.18-2.45v-.01l.14-.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M206.989,53.039l.8,1.12-.14.03-.78-1.08V53.1Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M207.509,34.789,207.5,33l3.51.9,2.64,1.21-3.13,2.66-.4-1.14-.56-1.16Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M207.969,56.869l-.67.22-.69.22-.04-.04,1.14-.37.14-.04v-.01l.17-.05v.05Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M207.709,56.9l-1.14.37-.18-.2-.76-3.3,1.24-.66.77,1.08.19,2.46.02.2Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M206.939,16.779l.75,1.84-.76-1.84Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M206.869,53.109l.78,1.08h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M207.649,47.829l-.01.01-2.17.37Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M207.5,32.959V33l-.17-.04-.01-1.6.17.08Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M207.509,34.789l2.05.68.56,1.16.4,1.14-.03.02-.41-1.15v-.01h-.01l-.55-1.15-2.05-.69v.04l-.13-.04-.01-1.83.17.04Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M207.479,36.159l2.41.45.01.02-2.56-.48h.14Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M207.469,34.859l.01,1.29h-.17l-.01-1.35.17.05Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M207.309,36.149h.03l-.03.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M207.309,36.149v.01l-2.57.08-.01-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M206.989,53.039l-.12.06-.05-.06-.61-.86.1-.08Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M206.969,109.839l-.33,2.6h-.01l.33-2.6Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M205.509,53.739l1.31-.7.05.06v.01l-1.24.66Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M206.209,52.179l.61.86-.62-.86Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M206.819,53.039l-1.31.7-1.01-.25,1.7-1.31Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M206.629,112.449l-.63,4.91-3.97,6.59-3.78,1.73-1.55-2.07v-3.53h3.96l-2.02-6.53h3.67l.38-1.1Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M207.809,58.7l-1.21-1.39h.01l.69-.22.67-.22.05-.01v-.01l.15-.05,3.65-1.17,3.23-1.04.02,1.69h-2.16l-2.62,1.29,1.32,2.88-1.1,1.75-1.79-2.25,1.42-.6Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M206.6,57.309l1.21,1.39,2.33.65-1.42.6,1.79,2.25-.08.12-1.88-2.37,1.42-.6-2.33-.65-1.21-1.39h.01l.13-.04.04.04Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M206.309,52.089v.01l-.1.08h-.01v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M205.8,49.249l.51,2.84-.11.08-.06-.07v-.01l-.5-2.82Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M206.2,52.169v.01l-.06-.08Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M206.139,52.1l-1.76,1.35h-.02l1.78-1.36Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M205.639,49.269l.5,2.82-.51-2.82Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M205.629,49.269l.51,2.82-1.78,1.36-.81-.2-1.62-3.48Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M205.629,49.259l.17-.02v.01l-.16.02h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M205.609,48.209l2.06-.35,2.31,3.84v.01h-.01l.76,1.76.04.11-2.97.58h-.01l-.8-1.12-.68-.94v-.01l-.51-2.84v-.01l-.19-1.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M205.629,49.239l-.18-.99.16-.03.19,1.02-.17.02v-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M205.629,49.259v.01l-3.7.5v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M206.219,57.069l-.76-3.3.05-.03.12.03.76,3.3.18.2-.13.04Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M205.609,48.209v.01l-.16.03v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M205.469,48.209l2.17-.37.01-.01.02.03-2.06.35-.16.03h-.01v-.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M205.439,48.239l.01.01-.1.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M204.669,48.349l.77-.13v.02l-.09.02-.82.14-.04-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M204.729,36.229l-.16.01-.58-.54.13-.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M204.669,48.349l-.18.04-.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M204.489,53.479l-.11-.03,1.76-1.35.06.08Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M204.529,48.4l.82-.14-.82.15-.04-.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M202.049,47.479l2.41.9-2.42-.89Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M204.459,48.379l-.1.02-2.34-.87.02-.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M204.329,53.489l.05-.04.11.03,1.71-1.3-1.7,1.31,1.01.25-.05.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M204.259,29.589l-2.47-3.07,5.56-6.07h.17l-5.56,6.07,2.47,3.07-5.27,4.66-.07-.08Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M204.359,48.409l-2.35-.87.01-.01,2.34.87.1-.02v.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M204.139,128.739l-.57-1.96h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M204.119,42.909l5.12.62-.02.02-5.27-.64h-.01l-.11-.05.06-.04h.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M203.989,35.7l-3.8.93h-.17l3.93-.96Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M202.009,44.029l1.81-1.16.12.04h.01l5.27.64v.9h-.01l-5.66,1.04h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M203.829,42.859l.11.05-.12-.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M203.829,42.859l-.01.01-.09-.04h-.01l-3.63-1.44,3.64,1.43Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M203.729,42.819l-3.64-1.43.1-.03,3.7,1.46-.06.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M203.719,42.829l-1.86,1.19h-3.74l-1.24-1.63,3.21-1Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M203.569,45.519h-.01v-.01l-.01-.02,5.66-1.04v.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M203.569,45.519l5.64-1.04v.62h1.03l-2.59,2.73-2.18.38h-.03v.01l-.77.13-.19.03h-.02l-2.41-.9-.6-.22,2.11-1.74Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M203.549,45.489l.01.02-.02-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M202.009,44.029l1.53,1.46Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M203.359,53.2l.19.05.81.2-.04.03-.94-.23Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M203.559,45.519l-2.11,1.74h-.17l.01-.01h.16l1.56-1.28Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M203.009,45.969l-1.56,1.28h-.16l1.56-1.28.55-.45.14-.03.02.02v.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M202.849,45.969l-1.56,1.28,1.55-1.28Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M202.689,112.449l-.38,1.1h-.01l.38-1.1Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M201.369,82.709l1.18,8.1-3,6.16h-13.31l-.41,2.01-.01.01-1.09.39-4.14-3.76,6.1-2.48v-4.48l8.77-5.95h5.91Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M202,44.019h-.14l1.86-1.19h.01l.09.04-1.81,1.16Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M202.029,123.949v.01l-3.78,1.72Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M202.019,47.529l-.01.01-.14-.05.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M202,44.029h-.15l.01-.01H202l.01.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M201.849,44.029h.16l1.53,1.46-.14.03-1.56-1.48Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M201.839,44.039l1.56,1.48Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M201.769,49.769l3.86-.52v.01l-3.7.5v.01l1.62,3.48-.19-.05-1.57-3.38Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M201.859,44.019l-.01.01h-3.73v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M201.849,44.029l-.01.01-.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M201.829,44.029l.01.01h-3.7l-.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M205.629,49.249l-3.86.52h-.01v-.01l3.87-.52Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M201.769,49.769l.02.05-.03-.05Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M201.879,47.479l-.6-.22h.17l.6.22-.01.01-.02.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M202.989,104.259l-1.96.92-1-2.95h2l-2.47-5.26,2.99-6.16-1.18-8.1h3.4l8.62,5.53-.22,4.96-2.21,2.18v5.11Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M201.029,105.189l-.91,3.65-.01-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M201.029,105.179v.01h-.01l-1-2.96h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M200.9,60.049v1.98l-.17-.03v-1.95Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M200.739,63.059l-.01,1.82-.17-.04.01-1.78Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M196,107.239l3.56-7.36v-2.91l2.47,5.26h-2.01l1,2.96h.01l-.92,3.64.01.01,2.55,3.6h.01v.01l-.38,1.1h-8.55l.06-3.1h-1.34l.43-3.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M200.569,63.059l-.01,1.78-1.91-.49.02-1.35Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M199.479,49.789l1.76-.92.77-1.33,2.35.87.1-.02h.03l.04.02.82-.15.1-.01.18.99-3.87.52v.01l.03.05,1.57,3.38-.41-.1-2.88-3.33-.16.01-.01-.01-.43.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M200.179,41.349l-.1.03-.06-.02-.35-4.73h.16Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M200.089,41.389l-3.21,1-.01-.02,3.21-.99Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M200.069,49.769l2.88,3.33.41.1.02.05-.6-.15-2.87-3.32Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M199.469,49.8l.43-.03.01.01-.46.03.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M199.839,36.629l.35,4.73-.1.03-.01-.01.1-.03-.35-4.72Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M199.659,36.629l-2.17-.03,2.34.02v.01h-.16l.35,4.73-3.31,1.03h-.01v-.01l3.31-1.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M199.469,49.8l.01-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M199.479,49.789l-.01.01h-.01l-.18.01.01-.01,1.78-.93.8-1.38.14.05-.77,1.33Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M199.289,49.8l-.01.01h-.08Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M201.069,48.869l-1.78.93-.09.01h-.1l-.67-1.24-.69-1.31h3.54l.6.22-.01.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M199.109,49.809h.09l-.09.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M198.429,48.569l.67,1.24h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M198.989,45.179l.06.07h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M199.049,45.259l-1.75.51,1.74-.52h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M198.139,44.039l.85,1.14Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M198.879,45.259l-.53.15.52-.16h.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M197.609,60.049h3.12V62l-1.89-.29-1.23-.84Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M198.649,64.349l1.91.49v.04l-2.08-.53L198.5,63h.17Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M193.689,115.8h2.4v-2.25h2.55l2.02,6.53H196.7v3.53l-3.09-4.13Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M198.429,48.569l-.71-1.31h.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M198.349,45.409l-2.17.64Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M198.259,48.569l-.69-1.28h.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M196.879,42.389l1.24,1.63-1.25-1.63Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M198.119,44.029h.01l.01.01h-.18v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M196.179,46.049l2.17-.64.53-.15v-.01l-.91-1.21h.17l.85,1.14.05.07-1.74.52-.97.28-.32.1h-.17Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M197.969,44.039l.91,1.21h-.01l-.91-1.21Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M197.959,44.029v.01l-.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M197.949,44.019v.01l-1.19-1.57Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M197.739,47.259h-.05l.04-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M197.729,47.249l-.04.01h-.13v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M198.939,49.819l-.68-1.25-.68-1.28.11-.03h.03l.71,1.31.66,1.24Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M197.689,47.259l-.11.03-.01-.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M198.669,61.719l-1.23-.85v-.82h.17v.82l1.23.84,1.89.29v.04Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M197.559,47.259h-.01l.02.03-3.08.71-.01-.03v-.01l3.08-.71Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M197.549,47.259h.02l.01.03h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M197.489,36.6l-2.15-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M197.509,34.529l-.51.76h-.16l.5-.75-.95-.94.12-.05Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M197.3,45.769l-.97.28Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M197.109,28.679l-1.19,1.85-.09-.11.9-1.42.21-.32v-5.6l8.6-6.3h.16l-8.59,6.3Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    d: "M196.879,67.549l-3.62,3.88,3.61-3.88Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    d: "M196.869,67.549l-3.61,3.88-1.93-9.28,4.3.12-.17,4.94Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    d: "M196.869,42.369l.01.02h-.01l1.25,1.63v.01h-.17v-.01l-1.19-1.56-.05-.07,3.31-1.03.06.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M196.839,35.289l-.01.01h-.49Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    d: "M196.569,49.949l2.35-.14-.66-1.24.68,1.25-2.2.13,8.3,7.18-1.55.32-.39,2.07-1.25.73-.01-.08,1.09-.64.39-2.08,1.55-.31Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M196.729,29l-.9,1.42h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M195.409,30.129l-4.87.79-1.66-3.89,16.71-11.57,1.28-.07,3.42-.17v1.56h-4.75l-8.6,6.3v5.6l-.21.32-.91,1.42-.24-.29-.15.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M196.709,42.389l.05.07-.06-.07Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M196.339,35.3l-.99.01.28-1.4.76-.31.95.94-.5.75Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M193.749,113.549h2.34v2.25h-2.4Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M197.559,47.249l-3.08.71h-.01l-.6-1.8v-.01h2.14l.32-.1.97-.28,1.75-.51v-.01l-.06-.07-.85-1.14h3.7l1.56,1.48-.55.45h-.01l-1.55,1.28h-3.73Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M195.919,30.529l3.17,3.64-.1.08-.5-.57-2.73-3.15.07-.11Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M195.579,30.129l.24.29-.07.11-.32-.38Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M193.259,71.429l2.35,11.28h-.15l-8.77,5.95-17.53-12.93v-1.39l10.41-5.69v-4.07l6.73-2.57,5.03.14Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M195.429,30.149l-4.88.8-.01-.03,4.87-.79Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M195.179,35.309l.28-1.4.88-.36.05.05-.76.31-.28,1.4Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M195.339,36.579l-.56-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M194.609,36.569l-.23-.9h.17l.23.9Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M194.489,48v.01l-.37.08Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M194.459,35.289l.04.18.05.2h-.17l-.09-.38.58-3.25h.17Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M194.319,48.009V48l.16-.03.01.03-.37.09-1.34.31-.13-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M194.479,47.969l-.16.03.15-.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M193.139,36.529l-.35-.86h1.59l.23.9h.17l.56.01,2.15.02,2.17.03.35,4.72-3.31,1.03v.01l.06.07,1.19,1.57.01.01.91,1.21-.52.16-2.17.64-.34.1H192.1l-.85.39.46-2.3.15-.7v-.01l-1.61-.84.05-.91.04-.76.15-2.9Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M192.789,35.669l-.47-1.1,1.13-2.55,1.42.02-.58,3.25.09.38Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M194.319,48v.01l-1.67.38Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M194.019,53.089h.17l-.35,1.68-.16-.06Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M194.019,53.089l-.34,1.62-.62-.23v-1.39Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2387",
    "data-name": "Rectangle 2387",
    width: 0.17,
    height: 0.01,
    transform: "translate(193.699 46.149)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M193.869,46.159l.6,1.8-.15.04-.62-1.84Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M191.359,46.569l.91-.41h1.43l.62,1.84-1.67.39-1.75-.14.33-1.62.09-.04Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M193.669,55.869l-1.4-.4v-.06l1.57.46v2.92h-.17Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M193.669,55.869v2.92h-1.4v-3.32Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M192.889,54.479v-1.39h.17v1.39l.62.23-.01.07Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M192.319,34.569l.47,1.1h-.17l-.47-1.1,1.13-2.55h.17Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M192.649,48.389l-.04.01-1.72-.13Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M192.649,48.389l-1.76-.12.01-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M190.889,48.269l1.72.13-1.72-.12Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M192.489,50.569h2.21l6.8,6.79.34,2.81-.16.09-.04-.3-.31-2.59-6.8-6.79h-2.2v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M192.329,50.569v.01h-.01l-.02-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M192.269,58.789h1.4v.01H192.1v-3.38l.17.05Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M192.269,46.159l-.91.41.89-.41Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M192.159,53.119h-.17l.17-2.55h.14l.02.01h.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M191.859,43.529v.01l-1.61-.84v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M191.239,46.539l.47-2.3-.46,2.3Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M191.319,46.589l.04-.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M192.249,46.159l-.89.41-.04.02-.09.04V46.6l.01-.04v-.01l.86-.39Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M191.249,46.539l.85-.39h.17l-.02.01h-.15l-.86.39v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M191.239,46.549v.01h-.01l-.15.06Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M191.239,46.559l-.01.04v-.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M191.229,46.6v.03h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M191.059,46.609v.02h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M179.759,44.539l6.44-3.87,3.04,1.59h.01l.13.07.7.37,1.61.84-.63,3.07-.01.02h.01l-.01.02-.01.05-.32,1.56v.01l-.29,1.41-.01.03,1.88.86h-.14l-.17,2.55-5.96-.04h-.17l-1.23,1.6h-.01l-4.06-2.61-.38-5-2.82-1.52v-1l2.23-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M191.049,46.649l-.01.05Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M190.9,48.249l-.01.02v-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M191.039,46.7l.01-.05.01-.02.02-.01.15-.06v.04l-.01.03h.01l-.33,1.62h-.01v.02l-.17-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M190.889,48.279l-.01.03v-.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M190.889,48.279l1.72.12.04-.01.13.01,1.34-.31.37-.08V48l3.08-.71.69,1.28.66,1.24-2.35.14,8.3,7.19-1.55.31-.39,2.08-1.09.64-.34-2.81-6.8-6.79h-2.21l-1.89-.87.02-.11.26-1.28Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M190.889,48.269v.01h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M190.889,48.269l-.01.01-.16-.01v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M190.719,48.269l-.29,1.41Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M190.589,49.709l.03-.12-.02.11,1.89.87Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M190.489,38.119l-.15,2.9-.16-.09.13-2.71Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M190.319,38.119l2.65-1.59-.35-.86h.17l.35.86-2.65,1.59-.18.1Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    d: "M190.879,48.309l-.26,1.28-.03.12,1.9.86h-.16l-1.9-.87v-.02l.29-1.41.16.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    d: "M190.429,49.7l1.9.87h-.03l-1.88-.86.01-.03Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    d: "M187.839,39.7l2.47-1.48-.14,2.71Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    d: "M190.309,38.219l-.13,2.71h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    d: "M190.289,41.789v-.01h.01l-.05.91Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    d: "M190.289,41.779v.01h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2564",
    "data-name": "Path 2564",
    d: "M190.279,41.789h.01l-.04.9-.16-.09.03-.72v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M190.249,42.689v.01l-.17-.09V42.6h.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M191.689,43.529l-1.61-.84v-.08l.17.09,1.61.84-.15.7-.47,2.3v.01l-.16.07-.02.01v-.02l.63-3.07Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M190.179,40.929l.16.09-.04.76h-.01l-.01.01-.16.08.01-.09.04-.75v-.1Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M190.169,41.029l-.04.75h-.01l-.24.13-.55.3h-.01l-3.02-1.59,1.46-.87Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M190.129,41.779l-.01.09v-.09Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M190.119,41.779v.01l-.24.12Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M190.119,41.879l-.03.72h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M190.079,42.689l1.61.84v.01l-1.61-.84Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    d: "M190.079,42.6v.01l-.67-.35.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    d: "M190.079,42.689v.01l-.7-.37Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    d: "M189.879,41.909l.24-.12v.09l-.31.16-.39.21-.09-.04Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    d: "M189.809,42.039l-.39.21Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2577",
    "data-name": "Path 2577",
    d: "M189.419,42.249l.39-.21.31-.16-.04.72Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    d: "M189.419,42.249l-.01.01-.09-.05h.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    d: "M189.409,42.259l.67.35v.08l-.7-.36-.13-.07.07-.05Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M186.3,40.619l3.02,1.59-3.03-1.58Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M188.879,27.029l1.66,3.89-.16.03-1.67-3.92,16.71-11.57,1.45-.07-1.28.07Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M190.169,40.929v.1l-2.41-1.28.08-.05Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M187.839,39.7l-.08.05-.09-.05,2.65-1.58-.01.1Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M186.289,40.629l3.03,1.58-.07.05h-.01l-3.04-1.59.09-.05h.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    d: "M186.289,40.619l-.09.05-.08-.04,1.55-.93.09.05-1.46.87Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    d: "M186.249,96.969l-.42,2.01.41-2.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    d: "M186.249,96.969h13.3v2.91l-3.55,7.36-3.1.18-.44,3.03H188.6l-.54-2.42-3.98-.58,1.62-7.86.13-.6v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M186.2,40.669l-6.44,3.87h-.17l6.53-3.91Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M186.109,57.1v1.61h-.17v-1.46Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M186.029,53.079l-1.29,1.67-.11-.07,1.23-1.6Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M185.939,57.249v1.46h-1.68Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M184.259,58.709h1.68v.01h-1.85l1.85-1.61v.14Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M185.829,98.989l-.13.6.12-.6Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M185.829,98.979v.01h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M185.819,98.989l-1.08.4h-.01v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M182.119,100.349l2.61-.96h.01l1.08-.4-.12.6-1.62,7.86-.74.21Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M184.729,99.389l-2.61.96-1.73.64h-3.75v1.9l-3.54-.7v-3.55l7.48-3.02h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M184.739,54.749l.01.01-5.92,7.6-.16-.01,5.91-7.59-.01-.01.05-.07h.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M184.619,54.679l-.05.07-4.18-2.67h.17Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M184.579,54.759l-5.91,7.59-5.84-.44.89-7.43-2.88-.48.04-1.84,9.51-.07,4.18,2.66Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M184.569,54.749l-4.18-2.66-9.51.07v-.01l9.51-.07Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    d: "M183.339,107.659l-1.78.51-1.17-7.18,1.73-.64Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M184.239,38.469l-2.24-.48-2.8-6.43h.17l2.8,6.43,2.24.47-.16,1.42h-.17Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M180.389,100.989l1.17,7.18-4.92,1.42v-8.6Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2605",
    "data-name": "Path 2605",
    d: "M182,37.989l2.24.48-.16,1.41h-.7l-.22,1.27-3.46.55-3.18.57,2.53-2.4-1.27-1.84,1.44-.79-.03-2.1-1.95-.18V31.5l1.96.06Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2606",
    "data-name": "Path 2606",
    d: "M179.869,41.689l-3.39.62.04-.04,3.18-.57,3.46-.55.22-1.27h.17l-.22,1.26Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2607",
    "data-name": "Path 2607",
    d: "M179.569,64.579v4.07l-10.41,5.68v.62h-.73l-3.48.01h-.42l7.37-9.59,7.17-.75.5-.05Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2608",
    "data-name": "Path 2608",
    d: "M177.189,45.549v-1h.17v1l2.82,1.52.38,5,4.06,2.61-4.06-2.6h-.17l-.38-5Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    d: "M179.019,35.139l-1.95-.18V31.5h.17v3.46l1.95.18.03,2.1-1.44.79,1.27,1.84-2.53,2.4-.21.04,2.57-2.43-1.27-1.85,1.44-.79Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2610",
    "data-name": "Path 2610",
    d: "M176.639,102.889v6.7l-7.24,2.1v-4.57l-.98-1.1,1.15-1V101.5l3.53.69Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2611",
    "data-name": "Path 2611",
    d: "M176.489,35.289v1.37l-1.06.37-.03-.04.92-.33v-1.37l-2.32-.16-.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2612",
    "data-name": "Path 2612",
    d: "M176.319,35.289v1.37l-.92.33-1.4-1.86Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2613",
    "data-name": "Path 2613",
    d: "M175.459,39.789v.02l-2.57-.35v-.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2614",
    "data-name": "Path 2614",
    d: "M175.429,37.029v.01h-.01l-.04-.05h.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    "data-name": "Path 2615",
    d: "M174,35.129l1.4,1.86h-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2616",
    "data-name": "Path 2616",
    d: "M175.389,80.339l11.3,8.32v4.48l-13.59,5.5v3.55l-3.53-.7-.56-2.5v-.01h-2.87l-1.74-3.92v-1.64h7.68v-.01l-.04-.73-.69-12.34Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    "data-name": "Path 2617",
    d: "M174,35.129l1.38,1.86-.12.05-1.38-1.84.1-.07Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2618",
    "data-name": "Path 2618",
    d: "M175.429,37.039l.2,2.77-.17-.02-.2-2.75.12-.05.04.05Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2619",
    "data-name": "Path 2619",
    d: "M173.879,35.2l1.38,1.84h-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2620",
    "data-name": "Path 2620",
    d: "M174.469,1.9l-.01.01L162.719.719Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2621",
    "data-name": "Path 2621",
    d: "M174.459,1.909l-1.59,1.6-4.52.93h-.01l-7.36,11.7-3.89,1.15h-.01l-5.58.34-2.75,2.12-7.37,2.18h-.01l-5.23,5.51h-3.41l-2.89-2.91-.13-5.2,4.59-2.62h.01v-3.83l-.01-.01-2.45-4.24h-.14l-9.45-.14V6.579l5.72-1.76.57-.17,7.88-2.74h13.69L161.4.589h.01l1.31.13Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M174,35.129h-.02l.01-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M173.979,35.129l-.1.07-.06-.08Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M173.549,54.479l-.89,7.43h-.01l.89-7.42-2.71-.45v-.01Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M172.889,39.459v1.25h-.17v-1.27Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M169.159,75.739l6.22,4.59h-4.04l.7,12.35.04.73H164.4v1.65l-6.37-4.59.18-5.42h5.19l1.56-2.34v-4.83h4.2Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M172.889,39.429v.03l-.17-.02v1.27l-1.27.01v-3.74l2.43-1.78,1.37,1.84h.01l.2,2.75Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M173.539,54.489l-.89,7.42-.59-.05-1.37-2.42.14-5.4Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M171.449,36.979v3.74h-.17v-3.74l2.54-1.86.06.08Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M173.709,54.489l-.89,7.43-.16-.01.89-7.43-2.72-.45v-.02Z",
    fill: "#038B9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2631",
    "data-name": "Path 2631",
    d: "M172.829,61.909l5.84.44-.01.01-6-.44v-.01l.16.01.89-7.43-2.88-.48v.02l-.16-.03.04-1.84h.17l-.04,1.84,2.88.48Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2632",
    "data-name": "Path 2632",
    d: "M172.059,61.859l.59.05v.01l-.76-.06-1.37-2.42.14-5.43.17.03-.14,5.4Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2633",
    "data-name": "Path 2633",
    d: "M169.159,75.739v2.14h-.01v-2.15h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2634",
    "data-name": "Path 2634",
    d: "M168.419,106.019l.98,1.1v4.56l-4.94-5.33,2.32-2.18Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2635",
    "data-name": "Path 2635",
    d: "M166.779,104.169l1.64,1.85Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2636",
    "data-name": "Path 2636",
    d: "M166.779,104.159v.01l-2.32,2.18Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2637",
    "data-name": "Path 2637",
    d: "M166.779,104.159l-2.32,2.19-2.36-2.54,2.3-2.31Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2638",
    "data-name": "Path 2638",
    d: "M164.959,77.879v4.83l-1.56,2.34,1.55-2.34v-4.83Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2639",
    "data-name": "Path 2639",
    d: "M169.159,74.959v.77h-.01v2.15h-4.2v4.83l-1.55,2.34h-5.18l.07-1.96,6.24-8.13h4.63Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M169.569,105.019l-1.15,1-1.64-1.85v-.01l-2.38-2.66-2.3,2.31-2.46-2.66,2.07-2.16h7.3l.56,2.5v3.53Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M166.189,24.1l-6.46-.92v-1.72l1.83.04.68-.93,3.22.07,2.68-.89,1.91,1.94v.53Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M161.709,98.989l-2.07,2.16-1.92-2.07.01-.09Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M161.4.589l-11.28,1.32h-13.69l-7.88,2.74,7.88-2.75h13.68Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2644",
    "data-name": "Path 2644",
    d: "M157.839,95.749l4.19,1.22H157.8Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M162.029,96.969l-4.19-1.22.19-5.28,6.37,4.59,1.74,3.92v.01h-8.42l.08-2.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2646",
    "data-name": "Path 2646",
    d: "M134.309,12.879v3.83h-.01v-3.84Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2647",
    "data-name": "Path 2647",
    d: "M131.849,8.629l2.45,4.24-2.46-4.24Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M134.3,16.709l-4.59,2.62.13,5.2-.01-.01-.13-5.2Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2649",
    "data-name": "Path 2649",
    d: "M129.839,24.529l2.89,2.91h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M122.259,6.579v1.91h-.02V6.569l5.74-1.75Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M118.869,45.9h-8.05l.04-.04h7.97l-1.66-2.63h.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M117.149,43.189l.02.03-1.48-.35v-.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2388",
    "data-name": "Rectangle 2388",
    width: 0.01,
    height: 0.03,
    transform: "translate(115.679 42.839)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M115.679,40.959v1.88l-.04-.01V41Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M115.679,40.959l-.04.04v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M118.829,45.859h-7.97l4.78-4.86v1.83l.04.01v.03h.01l1.48.35v.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M115.639,41l-4.8,4.86h-.08l4.88-4.95V41Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M115.639,41l-4.78,4.86h-.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M112.049,166.519l-2,3.48-5-1.84v-6.43Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M112.049,166.519l-7-4.79v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M112.509,5.569,111.619,4l6.85-.14.93-1.23-6.61.13V1.709l19.58-1.46-4.93,2.79-6.51,1.3-8.08,3.77-.89-.76h-5.54l-.76-.75h5.07l-1.17-1.51Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M110.859,45.859l-.04.04h-.02l.04-.04Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M108.229,108.629l1.1,2.4-.82,2.34-2.79.31.18-5.25Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M105.049,168.159l4.2,5.85-9.27,4.01.82,17.13-1.59-.17-4.37-6.69-.14-3.93-2.94-5.24-3.26-14.24,1.55-14.38h5.77l.39-.71,6.9,4.68v3.01h3.4l2.51-1.52.11,1.56-4.09,4.2h.01v6.44Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M107.7,2.4l1.51,1.13-2.09,1.34-3.65-.69Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M109.139,157.519l-4.09,4.2h-.01l4.09-4.2-.11-1.56v-.01h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M108.849,153.559l.17,2.39-2.51,1.53h-3.39v-3.01h-.01l-6.9-4.68H96.2l1.85-3.4,4.35-.03.12,3.83Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M108.509,113.369l-2.79.32v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M107.8,199.339l-5.77-.21-1.87-1.72,1.42-1.32Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M105.9,108.429l-.18,5.25-2.04.23-1.7.18-1.42-3.64,1.28-2.37v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M105.719,113.679v.01l-2.04.22Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M104.429,8.349h7.19l-2.47,1.73-9.45-.74,2.33-1.99Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2389",
    "data-name": "Rectangle 2389",
    width: 0.01,
    height: 3.01,
    transform: "translate(103.109 154.469)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M106.759,14.609l-7.6.41-2.06.11,3.98-4.22,1.65.01-1.14,2.82,3.41-2.8,1.46.02,9.81,4.01.08,2.81,1.77.64.99,1.86-1.76,1.17-3.06-1.09v3.98l-.87.37-2.66-1.26.92,2.03-1.06.46-3.87-3.2h-4.56v-1.29h4.5l2-1.63,3.96.06Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M102.3,143.109l.1,3.25-4.34.02-.01.01-1.85,3.4-.39.71h-5.77l-3.2-6.44v-9.71l4.25-1.2,3.81,3.91Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M101.979,114.1l-4.16.47.24-4.96-.23,4.95Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M98.069,109.369v-.01l-1.8.67,1.24-6.07,4.33,4.12-1.28,2.37,1.42,3.64v.01l-4.15.46.23-4.95Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M99.609,47.119v.01h-.07l.01-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M99.609,47.129l-.22.67-.66,2.08-.06.01.87-2.76Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M98.729,49.879l.66-2.08-.65,2.08Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M98.069,109.359v.01l-1.8.66Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M98.059,11.6l-4.38,1.16-.41-1.43,3.9-.9Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M98.059,22.739l-.53,1.29-4.98-.53,2.52-2.05Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M97.489,103.939l.02.02-1.24,6.07h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M97.489,103.939l-1.23,6.09-4.17,1.53.26,3.37-3.1,1-.97-2.17h-.01l-.76.05v-6.39H87.5l-4.78-.49-2.08-2.3-.38-4.48-.03-.37,7.2.06,3.1,2.21,5.58.55,1.4,1.34v.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M96.259,110.029l-4.15,1.53.25,3.37h-.01l-.26-3.37Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M43.719,15.849v-.01l19.61-.41,10.29,4.11,4.23-1.98,8.01,1.5,4.6-2.19-.9-1.85L93,13.5l.47,2.9,1.98.2-.48,2.4,4.25-2.81,3.08.35-3.29,3.42-8.08.89,1.1,1.62-5.25.96-9.25,6.85,9.25,5.02-.05,5.14h2.6l10.74-15.64h3.98l2.92,2.49-.04,3.57,6.06-2.39.57,7.58,4.63.8-.03,1.54-6.36,3.39-8.47.36-5.28,2.54v1.44l5.52-2.5.86.82-1.76,2.73,1.78,1.6,3.81.18-7.81,2.74-.27-1.19,2.87-1.37-4.31.75.65-2.08.22-.67v-.01h-.06l.01-.04H97.1l-2.74,2.37h-6.35l-1.96,1.35h-2.83l-.87-2.62-2.23.16-1.33-.98-.82-2.91-6.57,1.39-3.88-1.77H34.509v-1.44l-2.95-2.67,1.65-7.52.02-.03.02.02,1.62-1.74-1.42-1.47h-1.6l-1.56-1.78,13.42-11.59Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M90.839,89.119l-.52.85H88.9l.52-.85Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M87.459,178.239l-1.33-32.54.71-1.64,3.2,6.44v.01l-1.55,14.37,3.26,14.25,2.94,5.23.14,3.93,4.37,6.7-1.97-.2-6.09-7.88-.17-5.83Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M87.139,12.229l5.55-1.81-.84,2.25-3.21,1.07Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M88.629,16.249l-2.35,1.2-.92-1.2,2.57-1.11Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M88.269,113.759l.97,2.17h.01l3.1-1h.01l-.25-3.37,4.15-1.53h.01l1.8-.66-.01.24-.24,4.96,4.16-.47,1.7-.19,2.04-.22,2.79-.32.82-2.34,1.92,4.18-2.17,3.2,2.98-2.3,2.1.91-1.03,2.77,3.17-1.85,3.16,1.37-.18,1.87,6.85.42,7,4.55v3.38l-4.28,5.6-1.84,13.71-9.92,4.39-.96,6.17-4.08,7.12-7-4.8,4.09-4.2-.11-1.57h-.01l-.17-2.39-6.33-3.37-.12-3.83-.1-3.25-7.4-6.05-3.81-3.91-4.25,1.2-1.39.39-6.26-5.39,1.65-5.38,3.74-.46v-1.46h.01v-8.04l2.91-.2h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2691",
    "data-name": "Path 2691",
    d: "M87.5,87.949l-.01.01-4.13-.46v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2692",
    "data-name": "Path 2692",
    d: "M84.739,88.749l-1.38,1.03V87.5l4.13.46-.54.79Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    d: "M84.589,114.009v8.04h-.01v-8.04Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2694",
    "data-name": "Path 2694",
    d: "M83.359,87.489v.01h-2.58l-.01-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2695",
    "data-name": "Path 2695",
    d: "M81.619,88.689l-.84-1.19h2.58v1.72h-3.25v-.53h1.51Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    d: "M82.339,53.419l-2.13,1.47h-2.59l.01-.01H80.2Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M80.779,87.5l.84,1.19h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    d: "M73.809,112.629l.6-3.89-.19-.63-.43-1.46.81-1.16-.38-1.4-.03-.1,1.52-.1,3.05-4.13,1.47.01v.01l.03.37.37,4.48,2.08,2.3h.01l4.78.49v6.39l-2.91.19v.01h-.01v8.03l-7.04-4.02-5.13-2.93-.37-.21h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M77.539,118.019l-.01.01-.01-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M77.539,118.019h-.02l-5.11-2.93Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M77.519,118.019l.01.01-5.39,6.61h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M72.409,115.089l5.11,2.93-5.39,6.62-3.01-1.45.31-5.02,2.61-3.29Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M77.149,12.529l2.42-.94.55,1.78,1.37-1.78h2.28l-2.28,2.95,2.96,1.36-3.03.7-4.04-.96-3.63,1.58-5.28-2.05,4.25-1.09L70,12.939l4.62-1.57Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    d: "M82.339,53.419h-2.59l-2.14,1.46h.02l-.01.01h2.59Zm-9.81-5.89,1.6-.77,1.19.72.08.05,2.7.1.23.76-4.09.88-.1.17-3.37,5.44v.01h1.8v-.01l3.07-4.51,1.65-1.1H78.7l-.37,3.14v.01l1.3-.14.53-.05,1.79-1.39H86.1L84,52.279h1.5l2.11-1.44H86.1l1.96-1.35h6.35l2.73-2.36h2.4l-.87,2.76.06-.01-.02.06-1.56.27h-.01l-23.09,19.75h-.01l-.06,8.88-2.26-.06-.94-7.13v-.01l-14.27-.04H56.5l-5.99,7.53H50.5l-3.21-6.32h-.01V72.8l-3.89.14-1.12-1.69-.73-1.11h-.01v-.01l-13.88-1.79v.01l-3.97-3.96v-8.82l10.87-11.46h33l3.84,1.75.03.02-.76,1.65Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    d: "M74.7,90.569l-.88-.75v-1.03h2.53l.89.89v.89Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    d: "M74.5,105.159l.1.33-.08-.25Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    d: "M74.6,105.489l-.81,1.16-.01-.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M74.189,104.109l.31,1.05Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    d: "M73.789,106.649l.43,1.46-.44-1.47v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    d: "M74.219,104.089l.38,1.4-.1-.33-.29-1.08-.02-.09Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    d: "M74.209,104.079l.29,1.08-.31-1.05-.03-.12h.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    d: "M74.159,103.989l.03.12-.04-.12Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    d: "M74.139,49.439l-3.36,5.44h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    "data-name": "Path 2714",
    d: "M73.779,106.619v.01l-.01.01-.61-2.01h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    d: "M73.509,10.829l-8.57,2.92-1.5-1.77,8.1-2.06Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M78.189,140.379l-9.18-15.64.1-1.55h.01l3.01,1.45h.01l5.39-6.61,7.05,4.02v1.46l-3.74.46-1.66,5.39,6.26,5.39,1.4-.39v9.7l-.71,1.64Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M71.429,45.879l-.77,1.65.76-1.65Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M71.389,45.859l.03.02Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M70.779,71.639v.01l-14.27-.05Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M70.459,102.7l3.29-.29v.01l-3.28.29-1.17.97-.01-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2721",
    "data-name": "Path 2721",
    d: "M69.359,82.149h3.72l7.03,5.07h-5.88l1.3-1.44-3.4-2.26h-4.21Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2722",
    "data-name": "Path 2722",
    d: "M71.059,104.419l-.89,1.32-3.65-1.3v-.01l1.24-1.6,1.53.84.01.01,1.17-.97,3.28-.29.43,1.57h-.03l.04.12.31,1.05.02.08.07.24-.81,1.14-.61-1.99h-.01v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    d: "M67.749,102.819l.01.01-1.24,1.6,1.14-1.49Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    d: "M67.659,102.939l-1.14,1.49h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M66.889,102.339l.86.48-.09.12-1.15,1.49v.01l-.88-.31-.01-.01-2.45-3.32,3.68.39.03,1.15Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M66.679,93.139l.18,8.04-3.69-.39-2.16-2.9.73-.62Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2727",
    "data-name": "Path 2727",
    d: "M63.159,100.8h.01l2.45,3.32Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2728",
    "data-name": "Path 2728",
    d: "M62.519,88.169v.01l-.01.01-2.66,1.98h-.01v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2729",
    "data-name": "Path 2729",
    d: "M62.509,88.189l-.05.1-.01.01L59.9,90.2h-.04l-.01-.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2730",
    "data-name": "Path 2730",
    d: "M62.449,88.3l-2.15,4.06-.44-2.16h.04Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2731",
    "data-name": "Path 2731",
    d: "M61.739,97.269l-.73.62v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2732",
    "data-name": "Path 2732",
    d: "M60.809,96.149l-.41,1.46-.01-.01.41-1.45Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2733",
    "data-name": "Path 2733",
    d: "M58,96.529l.72-1.3,1.44.64.64.28-.41,1.45Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2734",
    "data-name": "Path 2734",
    d: "M61.739,97.269l-.73.61-.61-.27.41-1.46H60.8l-.64-.28-1.44-.65.05-.08.05-.09,1.03-1.84,6.83-.07Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2735",
    "data-name": "Path 2735",
    d: "M60.3,92.359l-.01.01-.44-2.17h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2736",
    "data-name": "Path 2736",
    d: "M60.159,95.869l-1.44-.64v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2737",
    "data-name": "Path 2737",
    d: "M59.849,93.209l-1.03,1.84.32-.59Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2738",
    "data-name": "Path 2738",
    d: "M59.849,90.169l.01.03h-.01l-.01-.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2390",
    "data-name": "Rectangle 2390",
    width: 2.05,
    height: 0.01,
    transform: "translate(57.789 90.159)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2739",
    "data-name": "Path 2739",
    d: "M58.769,95.139l-.05.08v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2740",
    "data-name": "Path 2740",
    d: "M58.719,95.209l-.73,1.31-3.34-1.68,1.13-2.01h2.4l-.34-2.63h2.01l.44,2.17Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2741",
    "data-name": "Path 2741",
    d: "M57.829,90.469l.31,2.32h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2742",
    "data-name": "Path 2742",
    d: "M58.719,95.229l-.72,1.3-.01-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2743",
    "data-name": "Path 2743",
    d: "M57.839,90.2l.34,2.63h-2.4l-1.13,2.01-.02-.01-.02-.02,1.13-2.02h2.4l-.31-2.32-.03-.26-.01-.04h2.05l.01.03Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2744",
    "data-name": "Path 2744",
    d: "M57.789,90.169l.01.04Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2745",
    "data-name": "Path 2745",
    d: "M57.429,89.069l-6.39.01v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2746",
    "data-name": "Path 2746",
    d: "M55.739,92.789l-1.13,2.02-.01-.01,1.13-2.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2747",
    "data-name": "Path 2747",
    d: "M54.609,94.809l.02.02-.03-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2391",
    "data-name": "Rectangle 2391",
    width: 0.014,
    height: 0.014,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 54.589, 94.809)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2748",
    "data-name": "Path 2748",
    d: "M47.289,72.809l3.21,6.32-3.22-6.32Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2749",
    "data-name": "Path 2749",
    d: "M47.279,72.8v.01h-.13l-3.76.13Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2750",
    "data-name": "Path 2750",
    d: "M47.149,72.809l-3.77.14v-.01h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2751",
    "data-name": "Path 2751",
    d: "M31.849,29.219h1.6l1.42,1.47-1.62,1.74-.02-.02,1.6-1.72-1.42-1.46h-1.6l-1.56-1.79,13.43-11.6h.03v.01l-13.42,11.59Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2752",
    "data-name": "Path 2752",
    d: "M42.269,71.249l1.12,1.69h-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2753",
    "data-name": "Path 2753",
    d: "M42.269,71.249l1.11,1.69-1.85-2.8Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2754",
    "data-name": "Path 2754",
    d: "M42.269,71.249l-.74-1.11h.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M41.529,70.129v.01l-13.88-1.8Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2756",
    "data-name": "Path 2756",
    d: "M41.529,70.139l-13.87-1.79h-.01v-.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2757",
    "data-name": "Path 2757",
    d: "M30.859,41.2l2.23,1.83v1.03h-1.63l-1.56-2.04Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2758",
    "data-name": "Path 2758",
    d: "M31.809,29.229h1.6l1.42,1.46-1.6,1.72-4.28-4.27-14.12.49-12.24,5.85-2.34-.19,6.41-4.19h-.03l.02-.01-3.33.06,3.89-5.26,8.03-3.01H15.2l.03-.01L9,22.1l1.4-1.96,7.39.09h.01v-2.92l6.57-2.65,16.26-.09,3.05,1.27-13.43,11.6Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2759",
    "data-name": "Path 2759",
    d: "M32.909,70.129h-1.99v4.04l3.37,7.18-1.75,1.35-4.27-8.08-.59-6.25-.02-.02,13.87,1.79,1.85,2.8v.01l3.77-.14h.13l3.22,6.32-2.58,3.24.01.01,3.11,6.69v.01l6.39-.01,2.32-3.82,2.93.06-.11,2.9-.11.08.05-.1.01-.01v-.01l-2.68,1.99h-2.05v.01l.01.04.03.26.3,2.32h-2.4L54.6,94.8l-2.24-2.28-2.6.69-10.4-4.34-6.38-14.98Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2392",
    "data-name": "Rectangle 2392",
    width: 0.01,
    height: 2.92,
    transform: "translate(17.789 17.309)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2760",
    "data-name": "Path 2760",
    d: "M15.239,21.879l-8.03,3.01,7.99-3.01Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2761",
    "data-name": "Path 2761",
    d: "M10.4,20.139,9,22.1h-.01l1.4-1.96Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2762",
    "data-name": "Path 2762",
    d: "M7.209,24.889l-3.89,5.26h-.01l3.89-5.26Z",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2763",
    "data-name": "Path 2763",
    d: "M6.659,30.1l-6.41,4.19,6.38-4.19Z",
    fill: "#e7e8e9"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2764",
    "data-name": "Path 2764",
    d: "M216.909,161.2l1.56-1h1.64",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2765",
    "data-name": "Path 2765",
    d: "M220.109,161.759v.03l-1.19,1.24h-2.01V163",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2766",
    "data-name": "Path 2766",
    d: "M208.059,159.579v.03H202.4l3.28,8.99h10.77l8.29-9.6.38-2.59-1.56.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2767",
    "data-name": "Path 2767",
    d: "M223.559,150.839h-3.92l-9.3,6.23-2.28-2.63",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x2: 1.53,
    transform: "translate(222.029 155.909)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2768",
    "data-name": "Path 2768",
    d: "M223.559,158.2v.03l-1.53-.92v-.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2769",
    "data-name": "Path 2769",
    d: "M82.339,53.419l-2.14,1.46h-2.59l2.14-1.46",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2770",
    "data-name": "Path 2770",
    d: "M99.609,47.129h-2.47",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2771",
    "data-name": "Path 2771",
    d: "M98.709,49.939l.02-.06.66-2.08",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2772",
    "data-name": "Path 2772",
    d: "M73.979,78.839l.06-8.88h.01l23.09-19.75",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2773",
    "data-name": "Path 2773",
    d: "M50.509,79.129,56.5,71.6h.01l14.27.05",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x2: 3.22,
    y2: 6.32,
    transform: "translate(47.279 72.809)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2774",
    "data-name": "Path 2774",
    d: "M41.529,70.139l1.85,2.8v.01l3.77-.14",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2775",
    "data-name": "Path 2775",
    d: "M70.659,47.529l.77-1.65h-.01l-.03-.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2776",
    "data-name": "Path 2776",
    d: "M75.319,47.479l-1.19-.72-1.6.77",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x1: 2.7,
    y1: 0.1,
    transform: "translate(75.399 47.529)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    y1: 5.44,
    x2: 3.36,
    transform: "translate(70.779 49.439)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2777",
    "data-name": "Path 2777",
    d: "M78.7,49.269h-1.41l-1.65,1.1-3.07,4.51v.01h-1.8v-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2778",
    "data-name": "Path 2778",
    d: "M79.629,52.279l-1.3.14v-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2779",
    "data-name": "Path 2779",
    d: "M115.639,41l-4.8,4.86-.04.04h.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2780",
    "data-name": "Path 2780",
    d: "M115.679,40.949v.01l-.04.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2781",
    "data-name": "Path 2781",
    d: "M115.689,42.869h-.01v-1.91",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2782",
    "data-name": "Path 2782",
    d: "M118.869,45.9l-1.68-2.67h-.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x1: 6.39,
    transform: "translate(51.039 89.069)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2783",
    "data-name": "Path 2783",
    d: "M41.529,70.139v-.01l-13.88-1.79",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2784",
    "data-name": "Path 2784",
    d: "M47.279,72.809V72.8l-3.89.14h-.01l-1.11-1.69",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2785",
    "data-name": "Path 2785",
    d: "M47.929,82.379l-.01-.01,2.58-3.24",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2786",
    "data-name": "Path 2786",
    d: "M166.189,24.1l3.86-1.88v-.53l-1.91-1.94-2.68.89-3.22-.07-.68.93-1.83-.04v1.72Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2787",
    "data-name": "Path 2787",
    d: "M198.669,63h-.17l-.02,1.35,2.08.53v-.04",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2788",
    "data-name": "Path 2788",
    d: "M161.4.589,150.109,1.9h-13.68l-7.88,2.75",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2789",
    "data-name": "Path 2789",
    d: "M172.869,3.509l1.59-1.6.01-.01L162.719.719",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2790",
    "data-name": "Path 2790",
    d: "M160.979,16.139l7.36-11.7h.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2791",
    "data-name": "Path 2791",
    d: "M148.749,19.749l2.75-2.12,5.58-.34",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2792",
    "data-name": "Path 2792",
    d: "M131.839,8.629l2.46,4.24v3.84l-4.6,2.61.13,5.2.01.01,2.88,2.91h3.42l5.23-5.51h.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2793",
    "data-name": "Path 2793",
    d: "M127.979,4.819l-5.74,1.75v1.92h.02l9.45.14",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2794",
    "data-name": "Path 2794",
    d: "M344.739,80.609l-1.12-1.17-1.83,2.6,1.83,1.71Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2795",
    "data-name": "Path 2795",
    d: "M287.769,44.879l14.76,8.62,17.08.19,2.05-4.19,5.52-1.15",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2796",
    "data-name": "Path 2796",
    d: "M322.249,43.279h-7.31l-14.93-3.7-.01.01-1.63,3.69h-.01l-6.06-1.85-.02.01-4.51,3.44",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2797",
    "data-name": "Path 2797",
    d: "M327.549,46.3v-.01l-3.84-.61",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2798",
    "data-name": "Path 2798",
    d: "M330.419,87.449l-2.19.49v1.29l.89,1.08,1.3-1.62Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2799",
    "data-name": "Path 2799",
    d: "M345.439,53.5v-7.21l-8.94-2.28-6.58-6.44h-6.38v.01l1.45,5.15h-.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2800",
    "data-name": "Path 2800",
    d: "M326.479,85.389l.01.01,1.8-1.02.06,1.74,10.62-3.79,3.47-7.77-6.19-10.19,3.18-3.47h-3.66l-1.17.76-2.3-3.77,2.92-2.56,2.01,3.83,2.81-1.93,2.13-1.47",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2801",
    "data-name": "Path 2801",
    d: "M313.019,76.289l-.96,2.6,3.7,6.16",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x2: 4.84,
    y2: 2.09,
    transform: "translate(306.029 73.279)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2802",
    "data-name": "Path 2802",
    d: "M299.589,75.2h.01l3.15,1.09",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2803",
    "data-name": "Path 2803",
    d: "M284.669,64.649l.27,5.48h.01l2.41.84h.01l11.4,3.94",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2804",
    "data-name": "Path 2804",
    d: "M276.049,57.069h-.01l.57,1.39,1.26,3.09h.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2805",
    "data-name": "Path 2805",
    d: "M281.379,49.749l-.01.01,1.07,4.93",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2806",
    "data-name": "Path 2806",
    d: "M322.249,43.289l1.46,2.39,3.84.62-.37,2.05-5.51,1.16-2.06,4.18-17.08-.18-14.77-8.62",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2807",
    "data-name": "Path 2807",
    d: "M359.149,54.129l2.5-.03,1.06-1.82-5.55-2.33.11,4.59,1.1.65Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2808",
    "data-name": "Path 2808",
    d: "M352.249,64.739l-.41,1.41,5.5-.81.43,2.12,1.25-.53.13-1.68,3.69-.94-.2-4.83-1.67-2.92-1.67-.49.95,4.39-3.4,3.09Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2809",
    "data-name": "Path 2809",
    d: "M351.279,67.459l1.99-.25.65.96-.72,2.26Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2810",
    "data-name": "Path 2810",
    d: "M356.589,66.529l-.96,1.74-1.27-1.44Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2811",
    "data-name": "Path 2811",
    d: "M350.569,96.329l-3.02-.32-1.1-1.37,1.1-2.52-1.09-2.41-1.99-.04-.49,4.25,2.82,3.39,3.3.42Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2812",
    "data-name": "Path 2812",
    d: "M341.059,103.869l1.33.26,2.38-1.97-.05-1.62Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2813",
    "data-name": "Path 2813",
    d: "M351.479,106.919v1.9l1.98-.6-.67-1.22,1.6-.41-1.36-4.24-1,2.62h-3.29Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2814",
    "data-name": "Path 2814",
    d: "M345.629,97.449l1.41,1.39-.46.85-1.14-1.11Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2815",
    "data-name": "Path 2815",
    d: "M347.039,100.849l1,.68,1.1-1.66-1.46-.18Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2816",
    "data-name": "Path 2816",
    d: "M350.779,99.109l1.38,1.78h1.51l-1.44-2.31Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2817",
    "data-name": "Path 2817",
    d: "M350.779,100.609l.78,1.36-.62.82-1.09-1.64Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2818",
    "data-name": "Path 2818",
    d: "M349.139,101.979l.71,1.07-.71.85-.8-.99Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2819",
    "data-name": "Path 2819",
    d: "M352.749,131.119l2.6-.31v-.97h-3.53v.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x1: 2.37,
    y2: 0.25,
    transform: "translate(340.699 110.349)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2820",
    "data-name": "Path 2820",
    d: "M330.949,114.829l-.04.01.13,3.68,2.09,3.66h6.65l3.29-4.2v-7.62",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2821",
    "data-name": "Path 2821",
    d: "M326.179,124.439v-2.81l-10.96-11.38-3.75-1.43,12.7,17.29Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2822",
    "data-name": "Path 2822",
    d: "M338.989,129.439l.2.95-13.7-2.32,2.06-1.65,3.42,1.3,3.08-.68Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2823",
    "data-name": "Path 2823",
    d: "M347.749,129.439h-2.12l.41,1.37h2.02l.85-.69Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2824",
    "data-name": "Path 2824",
    d: "M344.049,131.659l.62.76h1.47l-.51-1.1Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2825",
    "data-name": "Path 2825",
    d: "M351.819,129.849l-2.12,2.36,1.61.2,1.44-1.29Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2826",
    "data-name": "Path 2826",
    d: "M344.769,125.669l1.58-.48-.48-2.78.93-1.03.78,2.06,1.89.66v-1.48l-1.07-2.35,2.02-1.69-3.22.13-.66-.91,1.28-1.4,2.36.81,1.17-.1,1.74-2.06-1.53-.03-1,.65-3.29-.8-2.18,1.97.15,3.11-1.26,1.69Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2827",
    "data-name": "Path 2827",
    d: "M356.589,121.249l-.37,1.29,3.56-.37v-.92Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2828",
    "data-name": "Path 2828",
    d: "M357.409,112.959l-1.19,1.18-.45,2.92,1.64.4-.37-2.59.96-1.19Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2829",
    "data-name": "Path 2829",
    d: "M365.479,120.739l-.47-2.53-3.9.55Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2830",
    "data-name": "Path 2830",
    d: "M374.489,121.459v-.01l-3.79-1.97-3.53,2.87-3.73-1.47-.42,2.05,2.2-.08,5.44,2.27.98,2.79-1.81,1.1,4.66,1.62",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2831",
    "data-name": "Path 2831",
    d: "M343.709,60.809l2.19,4.75,2.66-.19.45-3.06-3.68-3",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2832",
    "data-name": "Path 2832",
    d: "M345.329,59.309l-1.62-1.33,2.1-.28-.37-4.19V53.5l-.01.01-3.26,2.25-2.13,1.46v.01l1.58,2.99,2.09.59Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2833",
    "data-name": "Path 2833",
    d: "M343.069,110.349v-2.78l-2.44.2-2.92,3.94-6.76,3.12,1.39.84,6.44-1.44,1.92-3.63,2.37-.24Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2834",
    "data-name": "Path 2834",
    d: "M318.249,107.769l1.17,3.81,4.83,4.12.38-1.47-4.56-6.73h-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2835",
    "data-name": "Path 2835",
    d: "M374.489,130.629l1.7.6,3.24-2.98,4.2,4.1,3.83.78-4.75-4.74.23-2.51-8.45-4.42Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2836",
    "data-name": "Path 2836",
    d: "M385.089,126.309l1.7,1.02,2.96-1.66v-1.72Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2837",
    "data-name": "Path 2837",
    d: "M387.469,121.489l3.44,2.47,1.38-.47-3.5-2.09Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2838",
    "data-name": "Path 2838",
    d: "M315.769,86.5v-1.45l-3.7-6.16.95-2.6-2.14-.92h-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    y1: 1.53,
    x2: 2.09,
    transform: "translate(313.669 86.499)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2839",
    "data-name": "Path 2839",
    d: "M306.649,86.779l2.14,1.79.81,4.27,1.51.45,1.08-1.35,2.01,2.26,1.11,4.13-.26,4.25v.02l1.72-3.38",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2840",
    "data-name": "Path 2840",
    d: "M308.009,77.429l-.01.01-1.04,7.21v.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2841",
    "data-name": "Path 2841",
    d: "M317.579,87.559v2.75h.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2842",
    "data-name": "Path 2842",
    d: "M317.629,84.109l-1.86.94h-.01V86.5",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2843",
    "data-name": "Path 2843",
    d: "M322.279,89.309l-.01-.01-1.12-3.47",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x1: 2.53,
    y1: 2.69,
    transform: "translate(322.959 90.029)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2844",
    "data-name": "Path 2844",
    d: "M322.139,96.019l2.32-2.33-2.48-3.38h-4.39v-2.75h-.01l-1.81-1.06h-.01l-2.09,1.52v.01l3.1,11.19-1.72,3.36-.01.02-.1,1.68,3.01,2.56.29.93h.01l1.81-.27-2.92-4.31.68-6.67,3.29,3.26",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2845",
    "data-name": "Path 2845",
    d: "M327.339,96.019h-5.2l-1.03,1.03v2.73l1.64,1.63,1.85-.26",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2846",
    "data-name": "Path 2846",
    d: "M326.489,85.389h-.01l-4.23-3.62-4.62,2.34,3.52,1.72,1.13,3.47v.01l.68.72,2.53,2.69,1.85,1.97V99.1l-2.74,2.05.07,2.95,5.25-3.47-.18-5.16-5.48-5.8.27-3.17,1.95-1.11",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2847",
    "data-name": "Path 2847",
    d: "M300.839,83.829l1.07-1.03,4.74,3.98.31-2.12-2.49-2.34",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x1: 1.17,
    y2: 0.55,
    transform: "translate(299.189 78.069)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2848",
    "data-name": "Path 2848",
    d: "M272.549,81.789l.27.32,2.71.86-1.27,1.3,1.2,1.56,2.16.25L278,84.3l.85.01,6.91,19.88,4.39-2.7.68-7.99,10.01-9.67-1.65-5.21v-.01l1.17-.54,1.71,2.28,1.99-.82.41,2.79,2.49,2.33,1.05-7.22,2.86-2.06.01-.01-4.84-2.09-.01.01-3.27,3",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x1: 3.28,
    y2: 0.87,
    transform: "translate(272.539 80.909)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2849",
    "data-name": "Path 2849",
    d: "M280.239,71.9l-3.8,3.5H274v2.59l1.82.69",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2850",
    "data-name": "Path 2850",
    d: "M277.649,67.489l1.75.99v.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    d: "M287.339,74.049l.02-3.08v-.01l-2.41-.83-.28-5.48",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    "data-name": "Path 2852",
    d: "M299.2,77h-.01l.4-1.8-.82-.29",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2853",
    "data-name": "Path 2853",
    d: "M298.769,74.909l-11.4-3.95v.01l-.03,3.08,9.67,3.66Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2854",
    "data-name": "Path 2854",
    d: "M299.6,75.2l-.4,1.8,1.34.33,1.53.38.68-1.42.01-.01Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2855",
    "data-name": "Path 2855",
    d: "M254.149,37.069v3.82h-15v4.94l2.01,2.51,4.3-1.73,2.56,1.73-3.11,1.51-.09,2.24,2.05,1.7,2.61-.72,2.31,1.93",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2856",
    "data-name": "Path 2856",
    d: "M287.759,44.869l-3.67-2.14-21.48-7.58-8.46,1.91",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x1: 0.01,
    transform: "translate(287.759 44.879)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2857",
    "data-name": "Path 2857",
    d: "M282.439,54.689l-1.06-4.94,6.38-4.86v-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2858",
    "data-name": "Path 2858",
    d: "M251.389,49.989l3.56-.83,4.24,2.91.46.31,3.93-.75,2.88,3.79,2.77-.12,2.71-2.23,6.4-.28.01.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2859",
    "data-name": "Path 2859",
    d: "M260.159,66.229l-.01-.01,1.1-2.32",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2860",
    "data-name": "Path 2860",
    d: "M264.809,76.569l-1.92-2.4-.32-.93",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2861",
    "data-name": "Path 2861",
    d: "M238.689,58.8v1.65l6.76,11.47,2.01.19,4.66,4.87,8.58,2.56h2.38",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2862",
    "data-name": "Path 2862",
    d: "M250.879,60.889l-.06,1.47h-4.23l-2.33-4.11-2.67.26-1.91.19",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x1: 0.89,
    y1: 1.44,
    transform: "translate(259.809 61.569)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2863",
    "data-name": "Path 2863",
    d: "M251.789,55.009l-2.31-1.93-2.61.72,4.16,3.45-.15,3.64,3.32-1.1,5.61,1.78h.01l.88,1.44.55.89",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2864",
    "data-name": "Path 2864",
    d: "M262.469,72.959l.1.28.33.93,1.91,2.4-1.73,2.97h7.49l1.97,2.24v.01h.01l3.27-.88v-2.24l-1.82-.68.01-2.58h2.43l3.8-3.5V71.9l-.84-3.41-1.75-1,.08-1.75,2.89-2.05h1.94",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x1: 4.99,
    y2: 4.62,
    transform: "translate(267.829 68.389)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2865",
    "data-name": "Path 2865",
    d: "M284.669,64.649l-2.1-.96h-.01l-4.05-1.85",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    y1: 1.74,
    x2: 0.22,
    transform: "translate(272.259 55.159)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2866",
    "data-name": "Path 2866",
    d: "M269.469,61.929l-1.31-3.85h.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2867",
    "data-name": "Path 2867",
    d: "M259.189,52.069l-4.24-2.9-3.56.82.4,5.01v.01l2.27-.9h3.73l8.8,7.05",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2868",
    "data-name": "Path 2868",
    d: "M269.479,61.929h-.01l-2.87-.77h-.01l-5.34,2.74-1.09,2.33,2.31,6.73,5.36.05,4.99-4.61v-.01l1.37-5.93",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2869",
    "data-name": "Path 2869",
    d: "M269.509,57.689l-1.34.39,1.31,3.85,3.83-1.97.88,2.5,4.32-.62-.63-.29-1.26-3.09",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2870",
    "data-name": "Path 2870",
    d: "M282.449,54.7h-.01v-.01l-4.09-1.89-6.41.28-2.7,2.23h-.01l-2.78.12-2.88-3.79-3.92.75-.46-.32",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2871",
    "data-name": "Path 2871",
    d: "M269.239,55.309l3.24-.15h.02l-.23,1.74h-.01l-2.75.79,3.44,1.12,3.66-.35h.01l-.57-1.39,6.39-2.37",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x1: 1.99,
    y1: 0.49,
    transform: "translate(240.399 54.489)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2872",
    "data-name": "Path 2872",
    d: "M241.6,58.519l2.66-.27-1.85-3.26h-.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x1: 0.08,
    y2: 0.02,
    transform: "translate(233.889 52.769)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x1: 0.93,
    y2: 0.2,
    transform: "translate(234.019 52.559)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2873",
    "data-name": "Path 2873",
    d: "M239.149,56.279l1.25-1.79-4.63-2.1h-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2874",
    "data-name": "Path 2874",
    d: "M233.889,52.8v2.56l3.58.91.05.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2875",
    "data-name": "Path 2875",
    d: "M238.689,58.8l.99-.1,1.92-.18-.01-.01-2.44-2.23h-1.63Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2876",
    "data-name": "Path 2876",
    d: "M207.489,31.439l-.17-.08.01,1.6",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2877",
    "data-name": "Path 2877",
    d: "M210.049,31.179l.24.18-.25,1.16",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2878",
    "data-name": "Path 2878",
    d: "M207.5,33l-.17-.04.01,1.83.13.04",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x1: 0.03,
    y2: 0.02,
    transform: "translate(210.489 37.769)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x1: 1.33,
    y2: 0.03,
    transform: "translate(209.809 29.439)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2879",
    "data-name": "Path 2879",
    d: "M213.909,28.819l-.02-.14-.02.02-.74.7",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2880",
    "data-name": "Path 2880",
    d: "M209.379,29.479h-.17l-.32.82,1.16.88.12-.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2881",
    "data-name": "Path 2881",
    d: "M230.009,44.469l.35-.78-.89-.36",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2882",
    "data-name": "Path 2882",
    d: "M223.429,48.349l-1.09,1.13,1.51.85.15-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    y1: 0.01,
    transform: "translate(218.189 49.329)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x1: 0.04,
    y1: 0.01,
    transform: "translate(211.209 39.769)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2883",
    "data-name": "Path 2883",
    d: "M195.829,30.419l-.07.11,2.73,3.15.5.57.1-.08",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2884",
    "data-name": "Path 2884",
    d: "M210.289,15.209l-3.42.18-1.45.07-16.71,11.57,1.67,3.92.16-.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2885",
    "data-name": "Path 2885",
    d: "M195.429,30.149l.32.38.07-.11",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2886",
    "data-name": "Path 2886",
    d: "M212.759,15.079l-2.47.12v.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    y1: 0.01,
    transform: "translate(212.769 15.079)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2887",
    "data-name": "Path 2887",
    d: "M209.329,20.449l-2.67,6.05,3.12,1.58h.17",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2888",
    "data-name": "Path 2888",
    d: "M354.369,44.329h1.64l-5.8-5.93-1.64-.05,4.66,5.75,2.28,4.25h1.69Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2889",
    "data-name": "Path 2889",
    d: "M207.469,34.849l-.17-.05.01,1.35v.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2890",
    "data-name": "Path 2890",
    d: "M234.019,52.769l.93-.21.8-.17h.01l4.62,2.1h.02l1.99.5v-.01l-1.25-2.18v-4.45l-2.01-2.51V40.9h15v-3.83h.02v-.01l8.44-1.89,21.47,7.57,3.68,2.15.02-.01v-.01l4.52-3.43,6.07,1.85.01-.01,1.63-3.69H300l14.93,3.7h7.32v-.01l2.72-.54v-.01l-1.46-5.15h6.4l6.57,6.44,8.95,2.28v7.21h.01l3.91-.68,2.11-3.15v-5.85l-6.03-6.85-5.84-.09,1-7.21,12.05.09,1.31-4.09,5.08,1.92.02-1.89,1.26.13,2.19,2.1-2.11,1.45-.26,4.31,8.58,8.12v-7.85l-4.84-4.66,11.47-3.63.14-1.17-5.76-1.57,2.24-1.75,5.16,1.06,3.5.07-2.81-3.01-18-3.56-27.9-.8-1.57-2.13-9.73-1.59-2.74,2.46h-7.88l-3.28-2.46H288.9L287.8,7.3h-16.44l-14.49,6.48,3.17,3.93-2.74,2.83-2.47-8.09-4.37-.34,2.1,4.78-16.9.46-15.65,6.42",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2891",
    "data-name": "Path 2891",
    d: "M229.049,46.649l.61,1.43-1.51.41.27,2.4,5.45,1.91h.02v-.01l.08-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2892",
    "data-name": "Path 2892",
    d: "M229.469,43.329l.87.36-.34.76",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2893",
    "data-name": "Path 2893",
    d: "M214.519,28.079l-.65.6v.02l.02.14",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2894",
    "data-name": "Path 2894",
    d: "M215.229,14.959l-.02-.01-2.44.13h-.01v.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2895",
    "data-name": "Path 2895",
    d: "M217.949,19.869l5.83.22.03-.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x1: 0.01,
    y2: 0.01,
    transform: "translate(201.279 47.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x1: 0.02,
    transform: "translate(192.249 46.159)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2896",
    "data-name": "Path 2896",
    d: "M170.829,54.039l-.17-.03-.14,5.43,1.37,2.42.76.06v-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x2: 0.01,
    y2: 0.01,
    transform: "translate(200.079 41.379)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x1: 0.01,
    transform: "translate(199.829 36.629)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2897",
    "data-name": "Path 2897",
    d: "M203.989,35.7l-.04-.03-3.93.96",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2898",
    "data-name": "Path 2898",
    d: "M207.339,36.149h-.03l-2.58.08",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    y1: 0.02,
    transform: "translate(217.459 51.449)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x2: 0.06,
    y2: 0.01,
    transform: "translate(215.809 51.049)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2899",
    "data-name": "Path 2899",
    d: "M192.619,35.669l.35.86-2.65,1.59",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2900",
    "data-name": "Path 2900",
    d: "M193.449,32.019h-.17l-1.13,2.55.47,1.1h.17",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2901",
    "data-name": "Path 2901",
    d: "M196.339,35.3h.49l.01-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2902",
    "data-name": "Path 2902",
    d: "M196.389,33.6l-.05-.05-.88.36-.28,1.4h.17",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    y2: 0.01,
    transform: "translate(193.699 46.149)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2903",
    "data-name": "Path 2903",
    d: "M197.609,60.049h-.17v.82l1.23.85,2.06.32V62",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2904",
    "data-name": "Path 2904",
    d: "M192.269,55.469l-.17-.05V58.8h1.57v-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2905",
    "data-name": "Path 2905",
    d: "M192.329,50.579h2.2l6.8,6.79.31,2.59.04.3.16-.09",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2906",
    "data-name": "Path 2906",
    d: "M193.059,53.089h-.17v1.39l.78.3.01-.07",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x1: 6.53,
    y2: 3.91,
    transform: "translate(179.589 40.629)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    d: "M177.359,44.549h-.17v1l2.82,1.53.38,5",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    d: "M187.669,39.7l-1.55.93.08.04",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    d: "M190.309,38.219l.01-.1-2.65,1.58.09.05",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    d: "M177.239,31.5h-.17v3.46l1.95.18.03,2.1-1.44.79,1.27,1.85-2.57,2.43.21-.04",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    x1: 0.16,
    y1: 0.01,
    transform: "translate(173.819 35.119)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M173.879,35.2l-.06-.08-2.54,1.86v3.74h.17",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M172.889,39.459l2.57.35v-.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M170.879,52.159h-.17l-.04,1.84.16.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M172.659,61.909v.01l6,.44.01-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M185.939,57.249v-.14l-1.85,1.61h1.85v-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    y2: 0.01,
    transform: "translate(205.449 48.239)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    x2: 0.01,
    transform: "translate(199.089 49.809)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    d: "M235.579,61.069l3.07-.62V58.8l-1.18-2.52-3.63-.92-14.66.48-.76.91-.5.59-2.83-.02,2.33,4.68,10.71.59,4.75-.97,2.7-.54",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x2: 0.01,
    transform: "translate(215.239 56.279)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    d: "M203.379,53.249l.94.23.04-.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2918",
    "data-name": "Path 2918",
    d: "M206.439,57.309h-.01l1.21,1.39,2.33.65-1.42.6,1.88,2.37.08-.12",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    x1: 0.01,
    y1: 0.01,
    transform: "translate(205.439 48.239)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2919",
    "data-name": "Path 2919",
    d: "M199.909,49.779l2.87,3.32.6.15-.02-.05",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2920",
    "data-name": "Path 2920",
    d: "M204.379,53.449l-.05.04,1.13.28",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M205.509,53.739l-.05.03.76,3.3.22.24.13-.04",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    x1: 0.03,
    y1: 0.01,
    transform: "translate(215.809 51.049)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M250,80.319l.76-.78-1.33-1.87-.59,1.88",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M225.769,63.789l-3.05,1.13,2.18.55Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    y1: 0.01,
    transform: "translate(232.129 67.209)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    y1: 0.03,
    x2: 0.07,
    transform: "translate(232.449 68.849)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    y1: 3.08,
    x2: 0.53,
    transform: "translate(230.589 69.449)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M250.879,80.9l-.88-.58-1.16-.77-.37-.24-3.02-4.93h-1.32v-.01l-.94-1.22",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M256,83.639l-1.7-.24-.81-.11",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    y1: 2.8,
    x2: 5.35,
    transform: "translate(243.119 89.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M232.539,68.929l-.09-.05-1.33.57h-.01l-.52,3.08-1.72.8-1.14-.14,10.64,18.49.22.69",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M242,73.149h1.2l.93,1.22h1.32l-1.6-2.6h-1.51",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    d: "M234.359,65.879l-2.23,1.34.39,1.63.02.08,8.07,4.21,1.39.01.34-1.38,2.97-.01-6.66-11.3-3.07.62",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2929",
    "data-name": "Path 2929",
    d: "M257.429,80.209,256,78.929l-2.26,2.54-2.86-.57,1.19,2.19,1.42.2.8.12",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    d: "M252.209,90.849l2.11,1.43,6.97-8.64-3.86-3.43L254.3,83.4l-.01.01,1.71.23v3.92l-3.79,1.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    d: "M227.729,67.7l1.65,1.15,2.75-1.64,2.23-1.33,1.22-4.8v-.01l-2.7.55-4.76.98-.5,2.33",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2932",
    "data-name": "Path 2932",
    d: "M248.469,89.579l-5.35,2.81v-.01l.35-1.43-3.78-.48-1.1,1.9,1.88,6.16,13.85-6.24-2.11-1.44v-2.27Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2933",
    "data-name": "Path 2933",
    d: "M227.729,67.7l1.24-2.3-1.35-.47-.49,2.33Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M227.7,73.259l.03-.07V67.7l-.6-.43-.95,3.51",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M239.079,151.629l1.44,3.42,3.47.15,5.89-18.9h-2.1l-6.85,7.11-.68,4.93Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    y1: 3.65,
    x2: 0.91,
    transform: "translate(200.119 105.189)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    y1: 0.01,
    transform: "translate(202.679 112.439)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M202.3,113.549h.01l.38-1.1",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M192.9,107.419l-.43,3.03h1.34l-.06,3.1",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M199.559,96.969v2.91l-3.56,7.36",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x1: 1,
    y1: 2.95,
    transform: "translate(200.029 102.229)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x1: 2.55,
    transform: "translate(196.089 113.549)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M193.689,115.8l-.08,3.68,3.09,4.13",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M193.689,115.8h2.4v-2.25h-2.34Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    x1: 0.12,
    y2: 0.6,
    transform: "translate(185.699 98.989)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M186.249,96.969h-.01l-.41,2.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    d: "M184.079,107.449l3.98.58.54,2.42h3.86l.44-3.03,3.1-.18,3.55-7.36v-2.91",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    x1: 3.53,
    y1: 0.69,
    transform: "translate(169.569 101.499)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2943",
    "data-name": "Path 2943",
    d: "M169.4,111.679v.01l7.24-2.1",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2944",
    "data-name": "Path 2944",
    d: "M166.779,104.159l-2.32,2.19,4.94,5.33v-4.56l-.98-1.1-1.64-1.85",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    d: "M199.109,126.809v9.98l-2.56,4.2.23,2.74",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M204.139,128.739l-.56-1.96h-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M210.519,131.759v-4.55H207.7l-.57,2h-.01l-2.81.1v-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2948",
    "data-name": "Path 2948",
    d: "M176.639,102.889v6.7l4.92-1.42",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2949",
    "data-name": "Path 2949",
    d: "M206.629,112.449h-3.95l-.38,1.1h-3.66l2.02,6.53H196.7v3.53l1.55,2.07,3.78-1.72v-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    x1: 5.93,
    y1: 10.18,
    transform: "translate(232.849 88.209)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2950",
    "data-name": "Path 2950",
    d: "M162.1,103.809l2.36,2.54,2.32-2.18",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    x2: 1.51,
    y2: 1.67,
    transform: "translate(236.999 99.879)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2951",
    "data-name": "Path 2951",
    d: "M240,100.479l-.73-1.25-.49-.84-.89.75",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x1: 0.01,
    transform: "translate(227.499 134.769)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2952",
    "data-name": "Path 2952",
    d: "M223.559,156.409l1.56-.03.1-.76,3.24-2.26-.24-6.81,7.6-6.24-.75-7.11",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2953",
    "data-name": "Path 2953",
    d: "M223.559,150.8v5.08",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2954",
    "data-name": "Path 2954",
    d: "M227.6,139.389v-.01l-.23-.18-1.6-1.32-.05.04",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2955",
    "data-name": "Path 2955",
    d: "M236.639,113.229v6.82l14.75-17.16-.6-3.01-10.25,1.52-.54-.92-1.49,1.07,1.51,1.7",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2956",
    "data-name": "Path 2956",
    d: "M212.549,143.729h-15.78l5.63,15.85h5.66v-5.17",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    x1: 0.98,
    y1: 1.36,
    transform: "translate(214.599 143.729)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2957",
    "data-name": "Path 2957",
    d: "M227.079,118.289l7.07,4.66,2.48-2.9v-6.82h.01l2.73-2.28",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2958",
    "data-name": "Path 2958",
    d: "M228.239,116.239v.01l-1.16,2.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x1: 2.58,
    y2: 0.36,
    transform: "translate(227.859 109.999)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2959",
    "data-name": "Path 2959",
    d: "M227.5,131.039h.01v3.73l7.56-1.57h.01l-.93-10.25-7.07-4.67v.01l-.44.77h-2.55l.66-1.13",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 1.54,
    y2: 3.83,
    transform: "translate(220.989 120.549)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2960",
    "data-name": "Path 2960",
    d: "M169.159,75.729h-.01v2.15",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2961",
    "data-name": "Path 2961",
    d: "M172.039,92.679l-.7-12.35h4.04l-6.22-4.59",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2962",
    "data-name": "Path 2962",
    d: "M164.4,93.419v-.01h7.68",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2963",
    "data-name": "Path 2963",
    d: "M158.219,85.049h-.01l-.18,5.42",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2964",
    "data-name": "Path 2964",
    d: "M164.959,77.879h-.01v4.83l-1.55,2.34",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 0.71,
    y2: 3.02,
    transform: "translate(220.639 117.929)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    y1: 2.62,
    x2: 1.05,
    transform: "translate(222.539 117.929)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2965",
    "data-name": "Path 2965",
    d: "M220.989,124.379l1.55-3.83h-.01l-1.89.4-.52,2.19",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    x1: 2.87,
    transform: "translate(166.139 98.989)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2966",
    "data-name": "Path 2966",
    d: "M159.639,101.149l2.46,2.66,2.3-2.31,2.38,2.66v.01l1.64,1.85,1.15-1v-3.53",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2967",
    "data-name": "Path 2967",
    d: "M186.689,88.659l-11.3-8.32h-4.04l.69,12.34.04.73v.01H164.4v1.64",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    y1: 5.5,
    x2: 13.59,
    transform: "translate(173.099 93.139)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2968",
    "data-name": "Path 2968",
    d: "M166.139,98.979h2.87v.01l.56,2.5,3.53.7",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2969",
    "data-name": "Path 2969",
    d: "M225.719,131.039l-1.05-1.47-4.56.69-.82,3.69",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    y1: 2.41,
    x2: 3.46,
    transform: "translate(222.259 137.919)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2970",
    "data-name": "Path 2970",
    d: "M213.019,133l.1,3.97h-3.15v3.56l2.58,3.2h2.05",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2971",
    "data-name": "Path 2971",
    d: "M222.019,135.049h.01l-.96,1.92",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2972",
    "data-name": "Path 2972",
    d: "M218,148.5l-2.42-3.41h-7.52v9.32l2.28,2.63,9.3-6.23v-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2973",
    "data-name": "Path 2973",
    d: "M184.729,99.389l-4.14-3.77h-.01l-7.48,3.02v3.55l3.54.7v-1.9h3.75",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2974",
    "data-name": "Path 2974",
    d: "M225.719,131.039v6.88l.05-.03,1.6,1.31.23.19v3.2l1.83-1.6v-2.74l-1.93-1.28v-5.93Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2975",
    "data-name": "Path 2975",
    d: "M230.429,109.989l.01.01.91.95h8.03l6.67-5.56-6.03-2.14L237,99.879l.89-.74-2.34-3.7h-5.76l-4.07,9.62",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2976",
    "data-name": "Path 2976",
    d: "M221.349,117.929h3.4l.97-1.69h2.52l.36-2.7-.74-3.18-4.87.68",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2977",
    "data-name": "Path 2977",
    d: "M185.829,98.979l.42-2.01h13.3l3-6.16",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2978",
    "data-name": "Path 2978",
    d: "M184.729,99.389h.01l1.08-.4h.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2979",
    "data-name": "Path 2979",
    d: "M186.689,88.659v4.48l-6.1,2.48,4.14,3.76",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2980",
    "data-name": "Path 2980",
    d: "M164.529,74.959l-6.24,8.13-.07,1.96h5.18l1.56-2.34v-4.83h4.2v-2.15",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    x1: 4.21,
    transform: "translate(164.949 74.959)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2981",
    "data-name": "Path 2981",
    d: "M161.709,98.989h4.43v-.01l-1.74-3.92-6.37-4.59-.19,5.28",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2982",
    "data-name": "Path 2982",
    d: "M157.8,96.969l-.08,2.02h.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2983",
    "data-name": "Path 2983",
    d: "M157.8,96.969h4.23l-4.19-1.22Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2984",
    "data-name": "Path 2984",
    d: "M201.369,82.709l1.18,8.1-2.99,6.16,2.47,5.26h-2.01l1,2.96h.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2985",
    "data-name": "Path 2985",
    d: "M210.959,95.389l2.21-2.18V93.2",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    y1: 3.76,
    x2: 7.97,
    transform: "translate(202.989 100.499)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    y1: 0.01,
    x2: 0.01,
    transform: "translate(213.589 83.629)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2986",
    "data-name": "Path 2986",
    d: "M195.609,82.709h9.16l8.62,5.53",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    x1: 3.61,
    y2: 3.88,
    transform: "translate(193.259 67.549)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2987",
    "data-name": "Path 2987",
    d: "M214.239,69.159l-5.02-.68-2.08,3.1-4.57-.91-1.81-2.2-3.88-.93v.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2988",
    "data-name": "Path 2988",
    d: "M179.569,64.579v-.01l-.5.05-7.17.75-7.37,9.59h.42l3.48-.01h.73",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2989",
    "data-name": "Path 2989",
    d: "M169.159,74.339v-.01l10.41-5.68",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2990",
    "data-name": "Path 2990",
    d: "M191.329,62.149l-5.03-.14-6.73,2.57v4.07l-10.41,5.69v1.39l17.53,12.93,8.77-5.95h.15l-2.35-11.28",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2991",
    "data-name": "Path 2991",
    d: "M191.329,62.149l1.93,9.28,3.62-3.88h-.01l-1.41-.34.17-4.94Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2992",
    "data-name": "Path 2992",
    d: "M214.6,143.729l.97,1.36L218,148.5l1.64,2.3h3.92l2.16-5.05v-3.16l-3.46-2.26-4.89,3.4Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2993",
    "data-name": "Path 2993",
    d: "M216.909,163h2.01l1.19-1.24v-1.59h-1.64l-1.56,1V163Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2994",
    "data-name": "Path 2994",
    d: "M223.559,155.879h-1.53v1.4l1.53.92v-2.32Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2995",
    "data-name": "Path 2995",
    d: "M229.319,82.129,223.9,72.8l2.97,2.42.8-1.89.03-.07-1.52-2.48-11.94-1.63v.01l-.64,14.47h13.09Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2996",
    "data-name": "Path 2996",
    d: "M222.989,111.039l7.44-1.05-4.71-4.93-.01-.01,4.08-9.61v-.01l3.06-7.22V88.2l-3.53-6.07-2.63,1.51h-13.1l-.2,4.6-.22,4.96-2.21,2.18v5.11",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2997",
    "data-name": "Path 2997",
    d: "M210.959,100.5l7.82,9,.01.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2998",
    "data-name": "Path 2998",
    d: "M206.969,109.839h-.01l-.33,2.6v.01l-.63,4.91-3.97,6.59-3.78,1.73.85,1.13h.01l4.46-.03.57,1.96.17.56,2.81-.09.57-2.01h2.82v4.56h.01l2.5,1.24,8.05,3.97.95-1.92-2.73-1.1h-.01l.83-3.69v-.01l4.56-.68-3.68-5.19-.87-1.24-.01-.01,1.24-5.2,1.64-6.89-4.2-1.53-11.49.32",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2999",
    "data-name": "Path 2999",
    d: "M201.029,105.189l-.92,3.64.01.01,2.55,3.6h3.97l.33-2.6.33-.01,11.48-.33h.02l-7.84-9v-.01l-7.97,3.77-1.96.92Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3000",
    "data-name": "Path 3000",
    d: "M183.339,107.659l.74-.21,1.62-7.86.13-.6v-.01l-.01.01-1.09.39v.01l-2.61.96",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3001",
    "data-name": "Path 3001",
    d: "M182.119,100.349l-1.73.64,1.17,7.18,1.78-.51Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3002",
    "data-name": "Path 3002",
    d: "M159.639,101.149l2.07-2.16h-3.98l-.01.09Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2649",
    "data-name": "Group 2649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2648",
    "data-name": "Group 2648",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3003",
    "data-name": "Path 3003",
    d: "M10.4,20.139h-.01l-1.4,1.96H9l6.23-.23-.03.01-7.99,3.01H7.2l-3.89,5.26h.01l3.33-.06-.02.01-6.38,4.19",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3004",
    "data-name": "Path 3004",
    d: "M17.8,17.309h-.01v2.92",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    x1: 3.05,
    y1: 1.27,
    transform: "translate(40.629 14.569)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    x1: 0.01,
    transform: "translate(43.709 15.849)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    x2: 0.3,
    y2: 2.32,
    transform: "translate(57.829 90.469)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3005",
    "data-name": "Path 3005",
    d: "M59.839,90.159h-2.05v.01l.01.04",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3006",
    "data-name": "Path 3006",
    d: "M54.649,94.839l3.34,1.68.73-1.31,1.57-2.84",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3007",
    "data-name": "Path 3007",
    d: "M55.739,92.789h-.01L54.6,94.8l-.01.01.01.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3008",
    "data-name": "Path 3008",
    d: "M58.769,95.139l-.05.07v.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x1: 0.71,
    y2: 1.25,
    transform: "translate(59.139 93.209)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    x2: 0.61,
    y2: 0.27,
    transform: "translate(60.399 97.609)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3009",
    "data-name": "Path 3009",
    d: "M58.719,95.229l-.73,1.29.01.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x1: 1.44,
    y1: 0.65,
    transform: "translate(58.719 95.219)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    y1: 1.45,
    x2: 0.41,
    transform: "translate(60.389 96.149)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3010",
    "data-name": "Path 3010",
    d: "M59.839,90.159v.01l.01.03.44,2.17.01-.01,2.15-4.06",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3011",
    "data-name": "Path 3011",
    d: "M61.739,97.269l-.73.61v.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3012",
    "data-name": "Path 3012",
    d: "M63.169,100.789l3.69.39-.18-8.04",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3013",
    "data-name": "Path 3013",
    d: "M72.039,114.879l-2.61,3.29-.31,5.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3014",
    "data-name": "Path 3014",
    d: "M72.129,124.639h.01l5.39-6.61.01-.01-5.13-2.93",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3015",
    "data-name": "Path 3015",
    d: "M82.719,106.929h-.01l-2.08-2.3-.37-4.48",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3016",
    "data-name": "Path 3016",
    d: "M84.579,122.049h.01V114l2.91-.19v-6.39",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3017",
    "data-name": "Path 3017",
    d: "M74.409,108.739l-.6,3.89-1.78,2.25h.01l.37.21,5.11,2.93h.02l7.04,4.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3018",
    "data-name": "Path 3018",
    d: "M74.519,105.239l.08.25-.82,1.14v.01l.44,1.47",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3019",
    "data-name": "Path 3019",
    d: "M74.159,103.989h-.01l.04.12.31,1.05",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3020",
    "data-name": "Path 3020",
    d: "M80.229,99.779v-.01l-1.47-.01-3.05,4.13",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2651",
    "data-name": "Group 2651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2650",
    "data-name": "Group 2650",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3021",
    "data-name": "Path 3021",
    d: "M100.159,197.409l1.87,1.72,5.77.21-6.22-3.25Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3022",
    "data-name": "Path 3022",
    d: "M90.049,150.5l-1.55,14.38,3.26,14.24,2.94,5.24.14,3.93,4.37,6.69,1.59.17-.82-17.13,9.27-4.01-4.2-5.85",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3023",
    "data-name": "Path 3023",
    d: "M96.209,149.789l-.39.71h-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3024",
    "data-name": "Path 3024",
    d: "M103.119,157.479v-3.01h-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    "data-name": "Line 102",
    x1: 2.51,
    y2: 1.52,
    transform: "translate(106.509 155.959)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3025",
    "data-name": "Path 3025",
    d: "M105.049,161.719l4.09-4.2-.11-1.57h-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3026",
    "data-name": "Path 3026",
    d: "M105.049,161.729v6.43l5,1.84,2-3.48-7-4.8",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3027",
    "data-name": "Path 3027",
    d: "M96.269,110.029l1.24-6.07v-.02l-1.4-1.34-5.58-.55-3.1-2.21-7.2-.06.03.37.38,4.48,2.08,2.3,4.78.49h.01v6.39",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3028",
    "data-name": "Path 3028",
    d: "M92.349,114.929h.01l-.25-3.37,4.15-1.53",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3029",
    "data-name": "Path 3029",
    d: "M88.269,113.759h.01l.97,2.17",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M66.889,102.339h-.01l-.03-1.15",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_103",
    "data-name": "Line 103",
    y1: 1.49,
    x2: 1.14,
    transform: "translate(66.519 102.939)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    y1: 0.01,
    transform: "translate(66.509 104.429)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M63.169,100.8h-.01l2.46,3.32",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M98.059,109.609l-.24,4.96,4.16-.47v-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    y1: 0.66,
    x2: 1.8,
    transform: "translate(96.269 109.369)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    "data-name": "Path 3033",
    d: "M101.839,108.079l-4.33-4.12-.02-.02-1.23,6.09",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3034",
    "data-name": "Path 3034",
    d: "M98.049,146.389l.01-.01,4.34-.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3035",
    "data-name": "Path 3035",
    d: "M90.039,150.5h5.77l.39-.71",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    y2: 0.01,
    transform: "translate(86.839 134.349)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3036",
    "data-name": "Path 3036",
    d: "M109.329,111.029l-1.1-2.4-2.33-.2",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    y1: 0.32,
    x2: 2.79,
    transform: "translate(105.719 113.369)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3037",
    "data-name": "Path 3037",
    d: "M102.4,146.359l-4.35.03-1.85,3.4h.01l6.9,4.68v3.01h3.4l2.51-1.53",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3038",
    "data-name": "Path 3038",
    d: "M101.979,114.089l1.7-.18,2.04-.22v-.01l.18-5.25-4.06-.36v.01l-1.28,2.37Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3039",
    "data-name": "Path 3039",
    d: "M80.839,123.969l-1.65,5.38,6.26,5.39,1.39-.39,4.25-1.2,3.81,3.91,7.4,6.05.1,3.25.12,3.83,6.33,3.37.17,2.39v.01l.11,1.56-4.09,4.2h.01v.01l7,4.79,4.08-7.12.96-6.17,9.92-4.39,1.84-13.71,4.28-5.6v-3.38l-7-4.55-6.85-.42.18-1.87-3.16-1.37-3.17,1.85,1.03-2.77-2.1-.91-2.98,2.3,2.17-3.2-1.92-4.18-.82,2.34-2.79.31-2.04.23-1.7.19-4.15.46.23-4.95.01-.24v-.01l-1.8.67h-.01l-4.17,1.53.26,3.37-3.1,1h-.01l-.97-2.17-.76.05H87.5l-2.91.2h-.01v8.04",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3040",
    "data-name": "Path 3040",
    d: "M74.179,103.989l-.43-1.57v-.01l-3.29.29-1.17.97",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3041",
    "data-name": "Path 3041",
    d: "M73.779,106.619l.81-1.14-.07-.24-.02-.08-.29-1.08-.02-.09",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3042",
    "data-name": "Path 3042",
    d: "M70.169,105.739l.89-1.32,2.1.2v.01l.61,2.01.01-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3043",
    "data-name": "Path 3043",
    d: "M67.749,102.819l-.09.12-1.15,1.49h.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3044",
    "data-name": "Path 3044",
    d: "M86.839,144.059v-9.7l-1.4.39-6.26-5.39,1.66-5.39,3.74-.46v-1.46l-7.05-4.02-.01-.01-5.39,6.62-3.01-1.45h-.01l-.1,1.55,9.18,15.64,7.94,5.32",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3045",
    "data-name": "Path 3045",
    d: "M86.129,145.7l1.33,32.54,3.51,2.84.17,5.83,6.09,7.88,1.97.2-4.37-6.7-.14-3.93-2.94-5.23-3.26-14.25,1.55-14.37v-.01l-3.2-6.44Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3046",
    "data-name": "Path 3046",
    d: "M83.359,89.779l1.38-1.03h2.21l.54-.79.01-.01-4.14-.46",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 3.25,
    transform: "translate(80.109 89.219)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3047",
    "data-name": "Path 3047",
    d: "M83.359,87.5v-.01h-2.59l.01.01.83,1.19",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3048",
    "data-name": "Path 3048",
    d: "M27.649,68.349l-3.97-3.96v-8.82l10.87-11.46h33l3.84,1.75.03.02-.76,1.65h1.87l1.6-.78,1.19.73.08.05,2.7.09v.01l.23.76-4.09.88-.1.17-3.37,5.44h1.8l3.06-4.52,1.65-1.1H78.7v.01l-.37,3.14,1.3-.13.53-.05,1.79-1.39H86.1l1.96-1.35h6.35l2.73-2.36.01-.01h2.46v.01l-.22.67-.65,2.08-.02.06h-.01l-1.56.27h-.01l-23.09,19.75-.06,8.88h-.01l-2.26-.06-.94-7.13v-.01l-14.27-.04-6,7.53",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3049",
    "data-name": "Path 3049",
    d: "M42.269,71.249l-.74-1.11-13.87-1.79",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3050",
    "data-name": "Path 3050",
    d: "M86.1,50.839h1.51l-2.11,1.44H84Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3051",
    "data-name": "Path 3051",
    d: "M54.629,94.829l-.03-.01.01-.01,1.13-2.02h2.4l-.31-2.32-.03-.26-.01-.04h2.06",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3052",
    "data-name": "Path 3052",
    d: "M58.819,95.049l.32-.59,1.16-2.08",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    y1: 1.3,
    x2: 0.72,
    transform: "translate(57.999 95.229)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    "data-name": "Path 3053",
    d: "M58,96.529l2.39,1.07.01.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3054",
    "data-name": "Path 3054",
    d: "M60.3,92.369v-.01l-.44-2.16-.01-.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    x1: 2.66,
    y2: 1.98,
    transform: "translate(59.849 88.189)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3055",
    "data-name": "Path 3055",
    d: "M62.459,88.289l.05-.1.01-.01v-.01l-2.68,1.99",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3056",
    "data-name": "Path 3056",
    d: "M60.3,92.379v-.01l2.15-4.07",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3057",
    "data-name": "Path 3057",
    d: "M60.4,97.609l.41-1.46H60.8l-.64-.28-1.44-.64",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    x2: 0.61,
    y2: 0.28,
    transform: "translate(60.399 97.609)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3058",
    "data-name": "Path 3058",
    d: "M61.009,97.889l.73-.62,4.94-4.13",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    x1: 0.19,
    y1: 8.05,
    transform: "translate(66.679 93.139)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3059",
    "data-name": "Path 3059",
    d: "M61.009,97.889l2.16,2.9v.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3060",
    "data-name": "Path 3060",
    d: "M66.679,93.139l-6.83.07-1.03,1.84-.05.09-.05.08v.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3061",
    "data-name": "Path 3061",
    d: "M73.789,106.649l.43,1.46.19.63",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3062",
    "data-name": "Path 3062",
    d: "M75.719,103.889h-.01l-1.52.1h-.03l.03.12.31,1.05.1.33",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3063",
    "data-name": "Path 3063",
    d: "M66.509,104.439l-.88-.31-.01-.01-2.45-3.32,3.68.39h.02l.02,1.15.86.48.01.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3064",
    "data-name": "Path 3064",
    d: "M66.519,104.439v-.01l1.24-1.6",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    d: "M66.519,104.439l3.65,1.3.02.01.88-1.32,2.09.2h.01l.61,1.99v.01l.01.02.81-1.16-.38-1.4-.03-.1-.43-1.57h-.01l-3.28.29-1.17.97-.01-.01-1.53-.84",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M83.359,87.5l4.13.46h.02l-.55.8h-2.21l-1.39,1.03v-.56",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M83.359,87.5v1.73h-3.25v-.54h1.51l-.84-1.19Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M82.339,53.419l-2.13,1.47h-2.59l.01-.01,2.12-1.46h2.59Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M110.819,45.9h8.06l-1.68-2.67h-.01l-.02-.01-1.48-.35v-1.92l-.01.01-.04.04-4.78,4.86Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3070",
    "data-name": "Path 3070",
    d: "M57.989,96.529l-3.34-1.68v-.01l1.13-2.01h2.4l-.34-2.63H59.9l2.55-1.9.01-.01.11-.08.11-2.9-2.93-.06-2.32,3.82-6.39.01v-.01l-3.11-6.69,2.58-3.24v-.01H50.5l-3.21-6.32h-.14l-3.76.13-1.12-1.69-.73-1.11h-.01l-13.88-1.8v.01h.01l.02.02.59,6.25,4.27,8.08,1.75-1.35-3.37-7.18v-4.04h1.99l.07,3.76,6.38,14.98,10.4,4.34,2.6-.69L54.6,94.8l.01.01.02.02.02.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3071",
    "data-name": "Path 3071",
    d: "M127.979,4.819l-5.72,1.76V8.5l9.45.13h.14l2.45,4.24.01.01v3.83h-.01l-4.59,2.62.13,5.2,2.89,2.91.01.01h3.41l5.23-5.52,7.37-2.18,2.76-2.11,5.57-.35h.01l3.89-1.15h.01l7.36-11.7,4.52-.93h.01l1.6-1.6h-.02L162.719.719l-1.31-.13h-.01l-11.28,1.32h-13.69l-7.88,2.74Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2653",
    "data-name": "Group 2653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2652",
    "data-name": "Group 2652",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3072",
    "data-name": "Path 3072",
    d: "M43.7,15.839l-3.07-1.27-16.26.09-6.57,2.65v2.92h-.01l-7.39-.09L9,22.1l6.2-.22h.04l-8.03,3.01-3.89,5.26,3.31-.05h.03l-6.41,4.19,2.34.19,12.24-5.85,14.12-.49,4.28,4.27.02.02,1.62-1.74-1.42-1.47h-1.6l-1.56-1.78,13.42-11.59v-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    y2: 0.01,
    transform: "translate(43.719 15.839)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    x2: 0.01,
    transform: "translate(43.719 15.849)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073",
    "data-name": "Path 3073",
    d: "M33.089,43.029l-2.23-1.83-.96.82,1.56,2.04h1.63Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    d: "M110.859,45.859h7.97l-1.66-2.63v-.01l-.02-.03-1.46-.35h-.01l-.04-.01v-1.92l-4.88,4.95h.1Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M104.049,22.739h2.7l3.87,3.2,1.06-.46-.92-2.03,2.66,1.26.87-.37v-3.98l3.06,1.09,1.76-1.17-.99-1.86-1.77-.64-.08-2.81-9.81-4.01-1.46-.02-3.41,2.8,1.14-2.82-1.65-.01-3.98,4.22,2.06-.11,7.6-.41,5.89,5.27-3.96-.06-2,1.63h-4.5v1.29Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    d: "M71.4,45.839l6.57-1.39.82,2.91,1.33.98,2.23-.16.87,2.62h2.83l1.96-1.35h6.35l2.74-2.37h2.46l-.01.04-.01.01-.87,2.76.06-.01h.01l4.31-.75-2.87,1.37.27,1.19,7.81-2.74-3.81-.18-1.78-1.6,1.76-2.73-.86-.82-5.52,2.5v-1.44l5.28-2.54,8.47-.36,6.36-3.39.03-1.54-4.63-.8-.57-7.58-6.06,2.39.04-3.57-2.92-2.49h-3.98l-10.74,15.64h-2.6l.05-5.14-9.25-5.02,9.25-6.85,5.25-.96-1.1-1.62,8.08-.89,3.29-3.42-3.08-.35L94.969,19l.48-2.4-1.98-.2L93,13.5l-3.44,1.52.9,1.85-4.6,2.19-8.01-1.5-4.23,1.98-10.29-4.11-19.61.41h-.04l-13.43,11.6,1.56,1.79h1.6l1.42,1.46-1.6,1.72-.02.03-1.65,7.52,2.95,2.67v1.44h33.01Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    "data-name": "Path 3077",
    d: "M95.069,21.449l-2.52,2.05,4.98.53.53-1.29Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    "data-name": "Path 3078",
    d: "M85.359,16.249l.92,1.2,2.35-1.2-.7-1.11Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3079",
    "data-name": "Path 3079",
    d: "M87.139,12.229l1.5,1.51,3.21-1.07.84-2.25Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    "data-name": "Path 3080",
    d: "M93.269,11.329l.41,1.43,4.38-1.16-.89-1.17Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    "data-name": "Path 3081",
    d: "M104.429,8.349l-2.4-1L99.7,9.339l9.45.74,2.47-1.73Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2655",
    "data-name": "Group 2655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2654",
    "data-name": "Group 2654",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    d: "M127.439,3.039l4.93-2.79-19.58,1.46v1.05l6.61-.13-.93,1.23-6.85.14.89,1.57-2.95-.48,1.17,1.51h-5.07l.76.75h5.54l.89.76,8.08-3.77Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3083",
    "data-name": "Path 3083",
    d: "M103.469,4.179l3.65.69,2.09-1.34L107.7,2.4Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3084",
    "data-name": "Path 3084",
    d: "M64.939,13.749l8.57-2.92-1.97-.91-8.1,2.06Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3085",
    "data-name": "Path 3085",
    d: "M74.619,11.369,70,12.939l2.72,1.14-4.25,1.09,5.28,2.05,3.63-1.58,4.04.96,3.03-.7-2.96-1.36,2.28-2.95h-2.28l-1.37,1.78-.55-1.78-2.42.94Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    x1: 0.01,
    transform: "translate(80.109 87.219)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3086",
    "data-name": "Path 3086",
    d: "M67.919,83.519h4.21l3.4,2.26-1.3,1.44h5.88l-7.03-5.07h-3.72Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3087",
    "data-name": "Path 3087",
    d: "M73.819,89.819l.88.75h2.54v-.89l-.89-.89h-2.53Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3088",
    "data-name": "Path 3088",
    d: "M89.419,89.119l-.52.85h1.42l.52-.85Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2657",
    "data-name": "Group 2657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2656",
    "data-name": "Group 2656",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3089",
    "data-name": "Path 3089",
    d: "M394.889,177.269l-.85,2.72,6.21-4.42-1.79-2.38v-2.72l-1.02.42v3.83Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3090",
    "data-name": "Path 3090",
    d: "M378.559,186.2l12.93-6.55v1.7l-9.95,6.55Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3091",
    "data-name": "Path 3091",
    d: "M325.569,152.6l10.89-5.1,8.08-8.93,4.42,1.96,1.96-4.08,7.4-.17-1.87,3.4,6.12,5.27,4.08-4.08v-5.7l1.88.59,2.12,10.21,6.64,9.35-.68,7.06-12.08,12.5-10.46-.6-1.28-7.06-3.57,1.53-3.4-2.97-20.67,4.52-1.28-1.53,1.7-4.09Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3092",
    "data-name": "Path 3092",
    d: "M200.559,64.839l.17.04.01-1.82h-.17l-1.9-.06-.02,1.35Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3093",
    "data-name": "Path 3093",
    d: "M214.3,31.689l-1.17.35-.05-.03h-.01l-1.9-1.06",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    "data-name": "Line 116",
    x1: 0.37,
    y1: 2.6,
    transform: "translate(214.469 31.639)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3094",
    "data-name": "Path 3094",
    d: "M210.209,31.179l.25.18-.27,1.23-.15-.07-2.55-1.16v.08l.01,1.52",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3095",
    "data-name": "Path 3095",
    d: "M213.809,35.109l-.1-.05h-.01l-2.53-1.16-3.67-.94V33l.01,1.79,2.05.68.56,1.16.4,1.14.04.1",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    x1: 2.27,
    y1: 0.93,
    transform: "translate(218.919 38.959)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3096",
    "data-name": "Path 3096",
    d: "M214.839,34.239l-1.03.87-3.25,2.76.68,1.88,6.04.96h.02l.07.01,3.71-.8",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097",
    "data-name": "Path 3097",
    d: "M220.119,38.189l.17-.1-2.37-3.85h-.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098",
    "data-name": "Path 3098",
    d: "M209.379,29.479l-.32.82,1.11.85.04.03.85-.2.11-.03,1.89,1.06h.01v.01l.06.03,1.17-.36h.01l.15-.05h.01l-.41-2.96-.02.02-.13.12-.02.02-.6.56h-.16l-1.99.04-1.33.03Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3099",
    "data-name": "Path 3099",
    d: "M221.179,39.889l-.09.02-.01.01-3.71.81-.09-.01v-.01h-.03l-6.01-.96.01.03.37,1.03-2.2,2.74V45.1",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3100",
    "data-name": "Path 3100",
    d: "M229.209,46.609h.02l.87-1.96.43-.96-1.11-.45-8.22-3.35h-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3101",
    "data-name": "Path 3101",
    d: "M217.119,48.889l1.07.44.15.06.34-1.04h4.92l-1.09,1.13,1.49.84.02.01,2.04-.16-1.93-2.47,4.92-1.05.16-.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3102",
    "data-name": "Path 3102",
    d: "M210.409,45.1h7.31l.8,1.51-1.44,2.26",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    x1: 0.76,
    y1: 1.84,
    transform: "translate(207.099 16.779)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_119",
    "data-name": "Line 119",
    x1: 0.03,
    y1: 0.06,
    transform: "translate(208.589 20.389)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3103",
    "data-name": "Path 3103",
    d: "M195.919,30.529l3.17,3.64.07.08,5.27-4.66-2.47-3.07,5.56-6.07h1.09",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3104",
    "data-name": "Path 3104",
    d: "M210.459,15.209l-.17.01-3.42.17-1.28.07-16.71,11.57,1.66,3.89.01.03,4.88-.8.15-.02.24.29h.01l.09.11,1.19-1.85v-5.6l8.59-6.3h1.41",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3105",
    "data-name": "Path 3105",
    d: "M212.929,15.079l-.16.01h-.01l-2.3.11v1.58h-3.35l.75,1.84.73,1.77.02.06h.89l-2.67,6.05,3.12,1.58h4.75l2.6-3.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    "data-name": "Path 3106",
    d: "M217.359,25l.01-.01-4.43-9.91",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3107",
    "data-name": "Path 3107",
    d: "M210.069,36.629l-.55-1.15-2.05-.69v.07l.01,1.29v.01l2.41.45h.05l.11.02.03.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    "data-name": "Path 3108",
    d: "M229.419,43.249l1.09.44-.42.94-.88,1.98v.01l.62,1.46-1.51.41.27,2.4,5.38,1.88v.01l.07.02-.02-.03v-.01l-3.92-8.11-.01-.02-.08-.16-.01-.02-.53-1.12-.01-.01-.04-.07",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_120",
    "data-name": "Line 120",
    y1: 0.01,
    transform: "translate(229.419 43.239)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3109",
    "data-name": "Path 3109",
    d: "M229.419,43.239l-6.47-13.39,3.12-8.49-6.03,2.47-.03-.06-2.06-3.9v-.01l5.86.21.14.01,2.93-1.46-11.5-3.67-.15.01-2.29.12h-.01l4.43,9.92-.06.07-2.61,3.01-.65.6v.02l.42,2.94.36,2.6h3.08l2.37,3.85-.15.1-1.2.77-.02.01,2.28.92h.01l8.23,3.35",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    "data-name": "Path 3110",
    d: "M207.809,47.829l2.6-2.73h-1.03v-.65",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3111",
    "data-name": "Path 3111",
    d: "M202.049,47.479l2.41.9h.02l.01.01.04.01.82-.14.09-.02h.01l.16-.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_121",
    "data-name": "Line 121",
    x1: 2.11,
    y2: 1.74,
    transform: "translate(201.449 45.519)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3112",
    "data-name": "Path 3112",
    d: "M203.559,45.519h.01l5.64-1.04.05-.01.12-.02h.01v-.9",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    "data-name": "Path 3113",
    d: "M202.009,44.029l1.53,1.46.02.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M193.869,46.159h-1.6l-.91.41-.04.02",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    x1: 0.01,
    y1: 0.01,
    transform: "translate(194.469 47.959)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3115",
    "data-name": "Path 3115",
    d: "M194.119,48.089l.37-.08V48",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    x2: 1.76,
    y2: 0.12,
    transform: "translate(190.889 48.269)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    "data-name": "Path 3116",
    d: "M200.189,41.359l-.1.03-3.21,1h-.01l1.25,1.63",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    "data-name": "Path 3117",
    d: "M198.129,44.029h3.88l1.81-1.16.01-.01.06-.04",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    "data-name": "Path 3118",
    d: "M170.829,54.039l-.14,5.4,1.37,2.42.59.05h.01l.16.01.89-7.43-2.88-.48v.03Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    x2: 0.02,
    y2: 0.04,
    transform: "translate(216.969 48.709)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    "data-name": "Path 3119",
    d: "M217.019,48.809l.02.05.01-.01,1.43-2.24-.79-1.51-.01-.01h-2.46",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3120",
    "data-name": "Path 3120",
    d: "M210.079,36.639v-.01h-.03l-.11-.02V36.6l-.05-.01-2.41-.44h-.14l-.03.01-2.57.08-.01-.01-.61-.56-.13.03-3.8.93h-.35l.35,4.73,3.7,1.46h.01l.22.09,5.12.62.03.01.12.01,2.19-2.74-.37-1.04-.01-.02-.68-1.88-.03-.08Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    "data-name": "Path 3121",
    d: "M210.149,51.7l5.43-.63.23-.02.15-.02,1.5.42.16.04.68-2.1-.11-.05-1.07-.45-.04-.02-.03-.01v-.01l-.03-.04-.03-.06v-.01l-.02-.03V48.7l-1.75-3.6v-.01h-4.8l-.01.01-2.59,2.73",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3122",
    "data-name": "Path 3122",
    d: "M198.119,44.019l-1.24-1.63-.01-.02,3.21-.99.1-.03-.35-4.72v-.01l-2.34-.02-2.15-.02-.56-.01-.23-.9",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3123",
    "data-name": "Path 3123",
    d: "M199.049,45.249l-.06-.07-.85-1.14",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3124",
    "data-name": "Path 3124",
    d: "M196.329,46.049l.97-.28,1.74-.52",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3125",
    "data-name": "Path 3125",
    d: "M191.239,46.559h-.01v.04l-.01.03h.01l.09-.04.04-.02.89-.41.02-.01h1.6",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_125",
    "data-name": "Line 125",
    x1: 0.47,
    y2: 2.3,
    transform: "translate(191.239 44.239)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    x2: 1.61,
    y2: 0.84,
    transform: "translate(190.249 42.699)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_127",
    "data-name": "Line 127",
    x1: 0.05,
    y2: 0.91,
    transform: "translate(190.249 41.779)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3126",
    "data-name": "Path 3126",
    d: "M192.789,35.669l.35.86-2.65,1.59",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3127",
    "data-name": "Path 3127",
    d: "M192.789,35.669h1.76l-.05-.2-.04-.18.58-3.25h-.17l-1.42-.02-1.13,2.55Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3128",
    "data-name": "Path 3128",
    d: "M197.509,34.529l-1-.98-.12.05-.76.31-.28,1.4.99-.01.5-.01H197Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3129",
    "data-name": "Path 3129",
    d: "M203.569,45.509h-.01l-.01-.02h-.01l-1.53-1.46-.01-.01h-3.88v.01h.01l.01.01.85,1.14.05.07h.01v.01l-1.75.51-.97.28-.32.1h-2.14v.01l.6,1.8h.01v.01l.01.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3130",
    "data-name": "Path 3130",
    d: "M197.729,47.249h3.72l1.56-1.28.55-.45v-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3131",
    "data-name": "Path 3131",
    d: "M200.9,60.049h-3.29v.82l1.23.84,1.89.29.17.03Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3132",
    "data-name": "Path 3132",
    d: "M193.669,58.789h.17v-2.92l-1.57-.46v3.38Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3133",
    "data-name": "Path 3133",
    d: "M201.839,60.169l.01.08,1.25-.73.39-2.07,1.55-.32-8.3-7.18,2.2-.13.15-.01-.66-1.24-.69-1.31-.01-.01-.04.01-.11.03h-.01l-3.08.71-.37.09-1.34.31-.13-.01-1.75-.14h-.01v.02l-.01.01v.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3134",
    "data-name": "Path 3134",
    d: "M190.619,49.589l-.03.12,1.9.86",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3135",
    "data-name": "Path 3135",
    d: "M193.059,53.089v1.39l.62.23.16.06.35-1.68h-1.13Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3136",
    "data-name": "Path 3136",
    d: "M201.839,60.169l-.34-2.81-6.8-6.79h-2.21l-1.89-.87.02-.11.26-1.28.01-.03v-.01l.01-.02.33-1.62V46.6l.01-.04v-.02h.01l.46-2.3.15-.7v-.01l-1.61-.84-.16-.09h-.01l-.66-.35-.09-.04h-.01l-3.02-1.59h-.01l-.09.05-6.44,3.87h-.17l-2.23.01v1l2.82,1.52.38,5,4.06,2.61",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3137",
    "data-name": "Path 3137",
    d: "M184.739,54.749l1.29-1.67,5.96.04h.17l.17-2.54v-.01h.16",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3138",
    "data-name": "Path 3138",
    d: "M190.289,41.779h.01l.04-.76",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    "data-name": "Line 128",
    x2: 0.01,
    transform: "translate(190.279 41.789)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    y1: 0.21,
    x2: 0.39,
    transform: "translate(189.419 42.039)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3139",
    "data-name": "Path 3139",
    d: "M187.839,39.7l-.08.05-1.46.87-.01.01,3.03,1.58.09.05",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3140",
    "data-name": "Path 3140",
    d: "M190.339,41.019l.15-2.9-.18.1-2.47,1.48,2.33,1.23h.01Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3141",
    "data-name": "Path 3141",
    d: "M189.409,42.259l.67.35.17.09v-.01l.04-.9v-.01l-.01.01-.16.08v.01l-.31.16-.39.21Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    "data-name": "Path 3142",
    d: "M177.239,31.5v3.46l1.95.18.03,2.1-1.44.79,1.27,1.84-2.53,2.4-.04.04,3.39-.62,3.46-.55.22-1.26h.7l.16-1.42-2.24-.47-2.8-6.43h-.17Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3143",
    "data-name": "Path 3143",
    d: "M174,35.129l1.38,1.86.04.05h.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3144",
    "data-name": "Path 3144",
    d: "M175.429,37.029l1.06-.37v-1.37l-2.5-.17",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    "data-name": "Path 3145",
    d: "M173.879,35.2l-2.43,1.78v3.74l1.27-.01h.17v-1.28l2.57.36.17.02-.2-2.77v-.01l-.03-.04-1.4-1.86-.01-.01-.01.01Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    "data-name": "Path 3146",
    d: "M170.879,52.159l-.04,1.84,2.88.48-.89,7.43,5.84.44.16.01,5.92-7.6-.01-.01-.11-.07h-.01l-4.06-2.6h-.17l-9.51.07Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M185.939,58.709h.17V57.1l-.17.15-1.68,1.46Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    x2: 0.19,
    y2: 2.46,
    transform: "translate(207.809 54.189)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    y1: 1.17,
    x2: 3.65,
    transform: "translate(208.169 55.629)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M207.789,54.159h.01l.02.03,2.96-.58h.01l.15-.03h.01l-.03-.06-.77-1.81V51.7l-.01-.01v-.01l-2.32-3.85h-.01l-.14.03-2.06.35v.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    y2: 0.01,
    transform: "translate(206.309 52.089)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M202.039,47.489l.01-.01-.6-.22h-3.73l.71,1.31.67,1.24h.01v.01l.09-.01h.08l.18-.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    y1: 0.01,
    x2: 0.01,
    transform: "translate(199.469 49.789)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M215.219,54.529l.03,1.75h2.61l-1.05-2.27h-.01l-.02.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    "data-name": "Line 134",
    x1: 1.44,
    y2: 0.46,
    transform: "translate(215.219 54.059)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    "data-name": "Path 3151",
    d: "M205.8,49.239l-.17.02-3.7.5v.01",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    "data-name": "Path 3152",
    d: "M203.549,53.249l.81.2h.02l.11.03,1.71-1.3v-.01l.11-.08-.51-2.84",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    "data-name": "Path 3153",
    d: "M206.609,57.309h-.01l1.21,1.39,2.33.65-1.42.6,1.79,2.25.09.12,1.18-1.87-1.32-2.88,2.62-1.29h2.16l-.02-1.75v-.01l-.17.05-3.23,1.05-3.65,1.18-.15.05-.05.02-.67.22",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    "data-name": "Path 3154",
    d: "M205.349,48.259l-.82.15-.04-.02h-.03v-.01l-2.42-.89-.02.04-.01.01-.77,1.33-1.76.92-.01.01h-.01l-.01.01.46-.03.16-.01,2.88,3.33.41.1.19.05-1.62-3.48,3.7-.5h.01l.16-.02v-.01l-.19-1.02-.16.03Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    "data-name": "Path 3155",
    d: "M206.989,53.039l-.68-.94-.1.08h-.01l-1.7,1.31,1.01.25.12.03",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    "data-name": "Path 3156",
    d: "M205.629,53.769l.76,3.3.18.2.04.04.69-.22.67-.22.05-.01V56.8l-.02-.15-.18-2.45v-.01h-.01l-.02-.03-.8-1.12-.12.06v.01Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3157",
    "data-name": "Path 3157",
    d: "M211.819,55.629l3.23-1.04.17-.06,1.44-.47.12-.04h.02v-.01l.82-2.5-.16-.04-1.5-.42-.09.01h-.03l-5.69.65h-.01l.78,1.81.02.06.86,1.99v.01l.02.04Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropeGermany);
export default __webpack_public_path__ + "static/media/europe_germany.ad9b73226247fc207ba2b6bb18ba00fb.svg";
export { ForwardRef as ReactComponent };